var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCeLogoFull = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 560,
    height: 93.363,
    viewBox: "0 0 560 93.363",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #f7981d;\n      }\n\n      .cls-4 {\n        fill: #9bc83a;\n      }\n\n      .cls-5 {\n        clip-path: url(#clip-path-2);\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-7 {\n        fill: #fefefe;\n      }\n\n      .cls-8 {\n        fill: #fdfdfd;\n      }\n\n      .cls-9 {\n        fill: #fcfcfc;\n      }\n\n      .cls-10 {\n        fill: #fbfbfb;\n      }\n\n      .cls-11 {\n        fill: #fafafa;\n      }\n\n      .cls-12 {\n        fill: #f9f9f9;\n      }\n\n      .cls-13 {\n        fill: #f8f8f8;\n      }\n\n      .cls-14 {\n        fill: #f7f7f7;\n      }\n\n      .cls-15 {\n        fill: #f6f6f6;\n      }\n\n      .cls-16 {\n        fill: #f5f5f5;\n      }\n\n      .cls-17 {\n        fill: #f4f4f4;\n      }\n\n      .cls-18 {\n        fill: #f3f3f3;\n      }\n\n      .cls-19 {\n        fill: #f2f2f2;\n      }\n\n      .cls-20 {\n        fill: #f1f1f2;\n      }\n\n      .cls-21 {\n        fill: #f0f0f1;\n      }\n\n      .cls-22 {\n        fill: #efeff0;\n      }\n\n      .cls-23 {\n        fill: #eeeeef;\n      }\n\n      .cls-24 {\n        fill: #ededee;\n      }\n\n      .cls-25 {\n        fill: #ececed;\n      }\n\n      .cls-26 {\n        fill: #ebebec;\n      }\n\n      .cls-27 {\n        fill: #eaeaeb;\n      }\n\n      .cls-28 {\n        fill: #e9e9ea;\n      }\n\n      .cls-29 {\n        fill: #e8e8e9;\n      }\n\n      .cls-30 {\n        fill: #e7e7e8;\n      }\n\n      .cls-31 {\n        fill: #e6e6e7;\n      }\n\n      .cls-32 {\n        fill: #e5e5e6;\n      }\n\n      .cls-33 {\n        fill: #e4e4e5;\n      }\n\n      .cls-34 {\n        fill: #e3e3e4;\n      }\n\n      .cls-35 {\n        fill: #e2e2e3;\n      }\n\n      .cls-36 {\n        fill: #e1e1e2;\n      }\n\n      .cls-37 {\n        fill: #e0e0e1;\n      }\n\n      .cls-38 {\n        fill: #dfdfe0;\n      }\n\n      .cls-39 {\n        fill: #dededf;\n      }\n\n      .cls-40 {\n        fill: #ddddde;\n      }\n\n      .cls-41 {\n        fill: #dcdcdd;\n      }\n\n      .cls-42 {\n        fill: #dbdbdc;\n      }\n\n      .cls-43 {\n        fill: #dadadb;\n      }\n\n      .cls-44 {\n        fill: #d9d9da;\n      }\n\n      .cls-45 {\n        fill: #d8d8d9;\n      }\n\n      .cls-46 {\n        fill: #d7d7d8;\n      }\n\n      .cls-47 {\n        fill: #d6d6d8;\n      }\n\n      .cls-48 {\n        fill: #d5d5d7;\n      }\n\n      .cls-49 {\n        fill: #d4d4d6;\n      }\n\n      .cls-50 {\n        fill: #d3d3d5;\n      }\n\n      .cls-51 {\n        fill: #d2d2d4;\n      }\n\n      .cls-52 {\n        fill: #d1d1d3;\n      }\n\n      .cls-53 {\n        fill: #d0d0d2;\n      }\n\n      .cls-54 {\n        fill: #cfcfd1;\n      }\n\n      .cls-55 {\n        fill: #ceced0;\n      }\n\n      .cls-56 {\n        fill: #cdcdcf;\n      }\n\n      .cls-57 {\n        fill: #ccccce;\n      }\n\n      .cls-58 {\n        fill: #cbcbcd;\n      }\n\n      .cls-59 {\n        fill: #cacacc;\n      }\n\n      .cls-60 {\n        fill: #c8cacb;\n      }\n\n      .cls-61 {\n        fill: #c7c9ca;\n      }\n\n      .cls-62 {\n        fill: #c6c8c9;\n      }\n\n      .cls-63 {\n        fill: #c5c7c8;\n      }\n\n      .cls-64 {\n        fill: #c4c6c7;\n      }\n\n      .cls-65 {\n        fill: #c3c5c6;\n      }\n\n      .cls-66 {\n        fill: #c2c4c5;\n      }\n\n      .cls-67 {\n        fill: #c1c3c4;\n      }\n\n      .cls-68 {\n        fill: #c0c2c3;\n      }\n\n      .cls-69 {\n        fill: #bfc1c2;\n      }\n\n      .cls-70 {\n        fill: #bec0c1;\n      }\n\n      .cls-71 {\n        fill: #bdbfc0;\n      }\n\n      .cls-72 {\n        fill: #bcbebf;\n      }\n\n      .cls-73 {\n        fill: #bbbdbf;\n      }\n\n      .cls-74 {\n        fill: #babcbe;\n      }\n\n      .cls-75 {\n        fill: #b9bbbd;\n      }\n\n      .cls-76 {\n        fill: #b8babc;\n      }\n\n      .cls-77 {\n        fill: #b7b9bb;\n      }\n\n      .cls-78 {\n        fill: #b6b8ba;\n      }\n\n      .cls-79 {\n        fill: #b5b7b9;\n      }\n\n      .cls-80 {\n        fill: #b4b6b8;\n      }\n\n      .cls-81 {\n        fill: #b3b5b7;\n      }\n\n      .cls-82 {\n        fill: #b2b4b6;\n      }\n\n      .cls-83 {\n        fill: #b1b3b5;\n      }\n\n      .cls-84 {\n        fill: #b0b2b4;\n      }\n\n      .cls-85 {\n        fill: #afb1b3;\n      }\n\n      .cls-86 {\n        fill: #aeb0b2;\n      }\n\n      .cls-87 {\n        fill: #adafb1;\n      }\n\n      .cls-88 {\n        fill: #acaeb0;\n      }\n\n      .cls-89 {\n        fill: #abadaf;\n      }\n\n      .cls-90 {\n        fill: #aaacae;\n      }\n\n      .cls-91 {\n        fill: #a9abad;\n      }\n\n      .cls-92 {\n        fill: #a8aaac;\n      }\n\n      .cls-93 {\n        fill: #a7a9ab;\n      }\n\n      .cls-94 {\n        fill: #a6a8aa;\n      }\n\n      .cls-95 {\n        fill: #a5a7a9;\n      }\n\n      .cls-96 {\n        fill: #a4a6a8;\n      }\n\n      .cls-97 {\n        fill: #a3a5a7;\n      }\n\n      .cls-98 {\n        fill: #a2a4a6;\n      }\n\n      .cls-99 {\n        fill: #a1a3a5;\n      }\n\n      .cls-100 {\n        fill: #a0a2a5;\n      }\n\n      .cls-101 {\n        fill: #9fa1a4;\n      }\n\n      .cls-102 {\n        fill: #9ea0a3;\n      }\n\n      .cls-103 {\n        fill: #9d9fa2;\n      }\n\n      .cls-104 {\n        fill: #9c9ea1;\n      }\n\n      .cls-105 {\n        fill: #9b9da0;\n      }\n\n      .cls-106 {\n        fill: #9a9c9f;\n      }\n\n      .cls-107 {\n        fill: #999b9e;\n      }\n\n      .cls-108 {\n        fill: #989a9d;\n      }\n\n      .cls-109 {\n        fill: #97999c;\n      }\n\n      .cls-110 {\n        fill: #96989b;\n      }\n\n      .cls-111 {\n        fill: #95979a;\n      }\n\n      .cls-112 {\n        fill: #949699;\n      }\n\n      .cls-113 {\n        fill: #939598;\n      }\n\n      .cls-114 {\n        fill: #a1a3a6;\n      }\n\n      .cls-115 {\n        fill: #bcbec0;\n      }\n\n      .cls-116 {\n        fill: #bdbfc1;\n      }\n\n      .cls-117 {\n        fill: #bec0c2;\n      }\n\n      .cls-118 {\n        fill: #bfc1c3;\n      }\n\n      .cls-119 {\n        fill: #c0c2c4;\n      }\n\n      .cls-120 {\n        fill: #c1c3c5;\n      }\n\n      .cls-121 {\n        fill: #c2c4c6;\n      }\n\n      .cls-122 {\n        fill: #c3c5c7;\n      }\n\n      .cls-123 {\n        fill: #c4c6c8;\n      }\n\n      .cls-124 {\n        fill: #c5c7c9;\n      }\n\n      .cls-125 {\n        fill: #c6c8ca;\n      }\n\n      .cls-126 {\n        fill: #c7c9cb;\n      }\n\n      .cls-127 {\n        fill: #c9cacb;\n      }\n\n      .cls-128 {\n        fill: #cacbcc;\n      }\n\n      .cls-129 {\n        fill: #cbcccd;\n      }\n\n      .cls-130 {\n        fill: #cccdce;\n      }\n\n      .cls-131 {\n        fill: #cdcecf;\n      }\n\n      .cls-132 {\n        fill: #cecfd0;\n      }\n\n      .cls-133 {\n        fill: #cfd0d1;\n      }\n\n      .cls-134 {\n        fill: #d0d1d2;\n      }\n\n      .cls-135 {\n        fill: #d1d2d3;\n      }\n\n      .cls-136 {\n        fill: #d2d3d4;\n      }\n\n      .cls-137 {\n        fill: #d3d4d5;\n      }\n\n      .cls-138 {\n        fill: #d4d5d6;\n      }\n\n      .cls-139 {\n        fill: #d5d6d7;\n      }\n\n      .cls-140 {\n        fill: #d6d7d8;\n      }\n\n      .cls-141 {\n        fill: #d7d8d9;\n      }\n\n      .cls-142 {\n        fill: #d8d9da;\n      }\n\n      .cls-143 {\n        fill: #d9dadb;\n      }\n\n      .cls-144 {\n        fill: #dadbdc;\n      }\n\n      .cls-145 {\n        fill: #dbdcdd;\n      }\n\n      .cls-146 {\n        fill: #dcddde;\n      }\n\n      .cls-147 {\n        fill: #dddedf;\n      }\n\n      .cls-148 {\n        fill: #dedfe0;\n      }\n\n      .cls-149 {\n        fill: #dfe0e1;\n      }\n\n      .cls-150 {\n        fill: #e0e1e2;\n      }\n\n      .cls-151 {\n        fill: #e1e2e3;\n      }\n\n      .cls-152 {\n        fill: #e2e3e4;\n      }\n\n      .cls-153 {\n        fill: #e3e4e5;\n      }\n\n      .cls-154 {\n        fill: #e4e5e6;\n      }\n\n      .cls-155 {\n        fill: #e5e6e7;\n      }\n\n      .cls-156 {\n        fill: #e6e7e8;\n      }\n\n      .cls-157 {\n        fill: #e7e8e9;\n      }\n\n      .cls-158 {\n        fill: #e8e9ea;\n      }\n\n      .cls-159 {\n        fill: #e9eaeb;\n      }\n\n      .cls-160 {\n        fill: #eaebec;\n      }\n\n      .cls-161 {\n        fill: #ebeced;\n      }\n\n      .cls-162 {\n        fill: #ecedee;\n      }\n\n      .cls-163 {\n        fill: #edeeef;\n      }\n\n      .cls-164 {\n        fill: #efefef;\n      }\n\n      .cls-165 {\n        fill: #f0f0f0;\n      }\n\n      .cls-166 {\n        fill: #f1f1f1;\n      }\n\n      .cls-167 {\n        clip-path: url(#clip-path-3);\n      }\n\n      .cls-168 {\n        clip-path: url(#clip-path-4);\n      }\n\n      .cls-169 {\n        clip-path: url(#clip-path-5);\n      }\n\n      .cls-170 {\n        clip-path: url(#clip-path-6);\n      }\n\n      .cls-171 {\n        clip-path: url(#clip-path-7);\n      }\n\n      .cls-172 {\n        clip-path: url(#clip-path-8);\n      }\n\n      .cls-173 {\n        clip-path: url(#clip-path-9);\n      }\n\n      .cls-174 {\n        clip-path: url(#clip-path-10);\n      }\n\n      .cls-175 {\n        clip-path: url(#clip-path-11);\n      }\n\n      .cls-176 {\n        clip-path: url(#clip-path-12);\n      }\n\n      .cls-177 {\n        clip-path: url(#clip-path-13);\n      }\n\n      .cls-178 {\n        clip-path: url(#clip-path-14);\n      }\n\n      .cls-179 {\n        clip-path: url(#clip-path-15);\n      }\n\n      .cls-180 {\n        clip-path: url(#clip-path-16);\n      }\n\n      .cls-181 {\n        clip-path: url(#clip-path-17);\n      }\n\n      .cls-182 {\n        clip-path: url(#clip-path-18);\n      }\n\n      .cls-183 {\n        clip-path: url(#clip-path-19);\n      }\n\n      .cls-184 {\n        clip-path: url(#clip-path-20);\n      }\n\n      .cls-185 {\n        clip-path: url(#clip-path-21);\n      }\n\n      .cls-186 {\n        clip-path: url(#clip-path-22);\n      }\n\n      .cls-187 {\n        clip-path: url(#clip-path-23);\n      }\n\n      .cls-188 {\n        clip-path: url(#clip-path-24);\n      }\n\n      .cls-189 {\n        clip-path: url(#clip-path-25);\n      }\n\n      .cls-190 {\n        clip-path: url(#clip-path-26);\n      }\n\n      .cls-191 {\n        clip-path: url(#clip-path-27);\n      }\n\n      .cls-192 {\n        clip-path: url(#clip-path-28);\n      }\n\n      .cls-193 {\n        clip-path: url(#clip-path-29);\n      }\n\n      .cls-194 {\n        clip-path: url(#clip-path-30);\n      }\n\n      .cls-195 {\n        clip-path: url(#clip-path-31);\n      }\n\n      .cls-196 {\n        clip-path: url(#clip-path-32);\n      }\n\n      .cls-197 {\n        clip-path: url(#clip-path-33);\n      }\n\n      .cls-198 {\n        clip-path: url(#clip-path-34);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1842",
    "data-name": "Rectangle 1842",
    className: "cls-1",
    width: 560,
    height: 93.362
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    className: "cls-1",
    d: "M2.62,46.68A44.062,44.062,0,1,1,46.681,90.742,44.062,44.062,0,0,1,2.62,46.68M46.681,0A46.681,46.681,0,1,0,93.363,46.68,46.735,46.735,0,0,0,46.681,0Z",
    transform: "translate(0 0.001)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    className: "cls-1",
    d: "M37.769,81.91l-1.5,2.912-1.5,2.911-1.5,2.911c.781.4,1.181.582,1.181.582q.595.282,1.2.541t1.217.5l.616.234.619.224,1.087-3.089q.542-1.544,1.086-3.089t1.086-3.088s.362-1.029,1.086-3.089l-.408-.147-.4-.155-.8-.329-.791-.356L39.268,79Z",
    transform: "translate(-33.272 -79)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2236",
    "data-name": "Rectangle 2236",
    className: "cls-1",
    width: 9.178,
    height: 13.727
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    className: "cls-1",
    d: "M27.756,74.555l-2.451,2.172L22.855,78.9,20.4,81.07c1.135,1.27,1.756,1.855,1.756,1.855q.908.9,1.875,1.735t1.985,1.608l1.032.754c.175.122.349.243.525.364l.531.355,1.8-2.735,1.8-2.736q.9-1.369,1.8-2.737L35.3,76.8l-.351-.235-.348-.242-.682-.5q-.675-.509-1.313-1.064t-1.241-1.148s-.411-.387-1.163-1.228Z",
    transform: "translate(-20.404 -72.384)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2238",
    "data-name": "Rectangle 2238",
    className: "cls-1",
    width: 14.9,
    height: 15.357
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    className: "cls-1",
    d: "M21.239,64.283l-3.072,1.134L15.1,66.551l-3.072,1.134c.6,1.6.967,2.37.967,2.37q.523,1.168,1.12,2.3t1.271,2.22q.337.542.689,1.076l.358.53s.123.174.368.522l2.666-1.9,2.665-1.9L24.793,71l2.667-1.9c-.162-.231-.242-.346-.242-.346q-.119-.174-.237-.35-.229-.354-.456-.711-.444-.718-.839-1.464t-.739-1.516s-.242-.508-.637-1.56l-3.072,1.133",
    transform: "translate(-12.024 -63.15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2240",
    "data-name": "Rectangle 2240",
    className: "cls-1",
    width: 15.436,
    height: 13.552
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    className: "cls-1",
    d: "M9.3,52.944v.021c0,.79.025,1.583.074,2.374S9.5,56.92,9.6,57.708s.217,1.573.364,2.354c.079.389.158.779.236,1.168.045.194.088.388.133.582,0,0,.046.193.141.579l3.175-.8,3.176-.8,3.176-.8,3.175-.8-.092-.381-.087-.382-.157-.77c-.1-.514-.175-1.033-.24-1.552s-.112-1.043-.144-1.568-.048-1.051-.048-1.578v-.014s0-.151,0-.455l-3.274-.058-3.275-.058-3.273-.058L9.31,52.262c0,.455-.007.682-.007.682",
    transform: "translate(-9.303 -52.262)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2242",
    "data-name": "Rectangle 2242",
    className: "cls-1",
    width: 13.867,
    height: 10.129
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    className: "cls-1",
    d: "M11.336,38.675q-.406,1.215-.732,2.455t-.567,2.5s-.182.836-.4,2.528l3.249.4,3.25.4,3.249.4,3.251.4c.143-1.118.262-1.668.262-1.668q.158-.829.373-1.645c.142-.542.3-1.082.482-1.614,0,0,.165-.538.589-1.58l-3.03-1.245-3.028-1.245L15.258,37.52l-3.029-1.244c-.643,1.582-.893,2.4-.893,2.4",
    transform: "translate(-9.64 -36.276)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2244",
    "data-name": "Rectangle 2244",
    className: "cls-1",
    width: 14.704,
    height: 11.487
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    className: "cls-1",
    d: "M18.916,24.505q-.819.981-1.572,2.014t-1.435,2.116s-.472.71-1.292,2.207L17.5,32.4l2.878,1.559,2.879,1.561,2.879,1.559c.54-.987.853-1.456.853-1.456q.452-.715.948-1.4t1.04-1.332s.351-.443,1.126-1.262l-2.371-2.259-2.371-2.258q-1.185-1.132-2.372-2.259l-2.37-2.26c-1.171,1.239-1.7,1.907-1.7,1.907",
    transform: "translate(-14.617 -22.598)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2246",
    "data-name": "Rectangle 2246",
    className: "cls-1",
    width: 15.482,
    height: 14.484
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    className: "cls-1",
    d: "M31.19,14.229q-1.12.62-2.2,1.312T26.891,17s-.7.492-2,1.589l2.121,2.5,2.118,2.5q1.061,1.247,2.12,2.5l2.12,2.495c.863-.726,1.324-1.05,1.324-1.05q.68-.5,1.39-.961t1.449-.867s.486-.284,1.5-.767q-1.391-2.965-1.392-2.964l-1.391-2.964q-.7-1.481-1.392-2.964s-.463-.988-1.391-2.964c-1.543.732-2.279,1.164-2.279,1.164",
    transform: "translate(-24.889 -13.065)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2248",
    "data-name": "Rectangle 2248",
    className: "cls-1",
    width: 14.145,
    height: 15.501
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    className: "cls-1",
    d: "M39.06,11.008q1.067,3.095,1.067,3.1.534,1.547,1.068,3.095t1.068,3.1s.355,1.032,1.068,3.1a25.294,25.294,0,0,1,6.6-1.328q-.215-3.268-.216-3.267-.107-1.636-.215-3.267l-.215-3.268s-.073-1.089-.217-3.267A38.523,38.523,0,0,0,39.06,11.008",
    transform: "translate(-39.06 -8.993)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2250",
    "data-name": "Rectangle 2250",
    className: "cls-1",
    width: 10.869,
    height: 14.398
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    className: "cls-1",
    d: "M54.994,12.2q-.063,1.635-.127,3.272t-.127,3.272l-.126,3.272a25.758,25.758,0,0,1,3.258.336c.716.122,1.071.2,1.071.2a21.517,21.517,0,0,1,2.31.606l.981-3.123q.49-1.561.982-3.123t.981-3.124s.327-1.041.981-3.123c-1.156-.361-2.035-.582-2.624-.723l-.885-.2s-.539-.123-1.626-.309a39.069,39.069,0,0,0-4.926-.508q-.126,3.272-.127,3.273",
    transform: "translate(-54.615 -8.93)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2252",
    "data-name": "Rectangle 2252",
    className: "cls-1",
    width: 10.565,
    height: 14.234
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    className: "cls-1",
    d: "M69.04,15.568l-1.311,3q-.654,1.5-1.31,3l-1.309,3a25.5,25.5,0,0,1,5.761,3.489l2.05-2.552,2.051-2.553L77.025,20.4l2.051-2.552a38.515,38.515,0,0,0-8.726-5.284q-1.31,3-1.309,3",
    transform: "translate(-65.111 -12.567)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2254",
    "data-name": "Rectangle 2254",
    className: "cls-1",
    width: 13.965,
    height: 15.493
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    className: "cls-1",
    d: "M80.944,24.06l-2.31,2.322q-1.153,1.162-2.308,2.323l-2.308,2.322a25.6,25.6,0,0,1,4.114,5.342l2.835-1.638L83.8,33.092l2.835-1.638,2.834-1.639a38.714,38.714,0,0,0-6.221-8.078q-2.309,2.322-2.308,2.323",
    transform: "translate(-74.018 -21.737)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2256",
    "data-name": "Rectangle 2256",
    className: "cls-1",
    width: 15.455,
    height: 14.631
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    className: "cls-1",
    d: "M89.112,36.493,86.119,37.82l-2.994,1.327-2.993,1.328a25.27,25.27,0,0,1,1.883,6.458l3.238-.491,3.238-.491,3.237-.49,3.238-.491A38.406,38.406,0,0,0,92.1,35.165Z",
    transform: "translate(-80.132 -35.165)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2258",
    "data-name": "Rectangle 2258",
    className: "cls-1",
    width: 14.833,
    height: 11.769
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    className: "cls-1",
    d: "M92.319,51.2l-3.271.146-3.271.147-3.273.146q.026,1.154.027,1.153v.014s.01.471-.038,1.4a25.5,25.5,0,0,1-.57,4.153l3.2.713,3.2.712,3.2.712,3.2.712a38.629,38.629,0,0,0,.864-6.289c.072-1.408.058-2.111.058-2.111v-.021s-.014-.579-.039-1.736l-3.271.147",
    transform: "translate(-81.923 -51.056)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2260",
    "data-name": "Rectangle 2260",
    className: "cls-1",
    width: 13.721,
    height: 10.157
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    className: "cls-1",
    d: "M77.672,68.435l2.716,1.828L83.1,72.092l2.716,1.828,2.716,1.828a38.438,38.438,0,0,0,4.528-9.15l-3.1-1.05-3.1-1.048-3.1-1.05-3.1-1.049a25.4,25.4,0,0,1-2.986,6.032",
    transform: "translate(-77.672 -62.403)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2262",
    "data-name": "Rectangle 2262",
    className: "cls-1",
    width: 15.393,
    height: 13.346
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    className: "cls-1",
    d: "M70.106,76.338l1.873,2.687q.935,1.343,1.872,2.686L75.722,84.4l1.872,2.686A38.724,38.724,0,0,0,85.119,80.2q-2.508-2.106-2.509-2.1L80.1,76l-2.508-2.106-2.508-2.1a25.663,25.663,0,0,1-4.981,4.553",
    transform: "translate(-70.106 -71.785)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2264",
    "data-name": "Rectangle 2264",
    className: "cls-1",
    width: 15.013,
    height: 15.298
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    className: "cls-1",
    d: "M63.854,80.1q1.167,3.06,1.167,3.059l1.167,3.06q.583,1.53,1.167,3.059l1.167,3.06A38.494,38.494,0,0,0,73.3,90.127l-1.575-2.872q-.786-1.435-1.574-2.87t-1.574-2.872L67,78.642A25.09,25.09,0,0,1,63.854,80.1",
    transform: "translate(-63.854 -78.642)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2266",
    "data-name": "Rectangle 2266",
    className: "cls-1",
    width: 9.444,
    height: 13.692
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1879",
    "data-name": "Group 1879",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1794",
    "data-name": "Group 1794",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1793",
    "data-name": "Group 1793",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    className: "cls-3",
    d: "M135.067,43.391a23.866,23.866,0,0,1,1.415-8.016,22.288,22.288,0,0,1,4.149-7.167,20.891,20.891,0,0,1,6.7-5.124,20.109,20.109,0,0,1,8.99-1.949,18.779,18.779,0,0,1,10.248,2.7,16.81,16.81,0,0,1,6.35,7.041l-4.464,2.892a12.98,12.98,0,0,0-2.42-3.583,12.462,12.462,0,0,0-3.081-2.326,13.259,13.259,0,0,0-3.426-1.257,16.473,16.473,0,0,0-3.458-.377,13.638,13.638,0,0,0-6.57,1.54,15.183,15.183,0,0,0-4.809,4.024,17.408,17.408,0,0,0-2.923,5.6,20.8,20.8,0,0,0-.974,6.255,19.3,19.3,0,0,0,1.163,6.7,18.452,18.452,0,0,0,3.238,5.627,15.767,15.767,0,0,0,4.9,3.9,13.326,13.326,0,0,0,6.161,1.446,15.59,15.59,0,0,0,3.615-.44,13.2,13.2,0,0,0,3.552-1.415A15.17,15.17,0,0,0,166.6,57a11.983,11.983,0,0,0,2.42-3.552l4.715,2.578a13.908,13.908,0,0,1-2.986,4.432,18.886,18.886,0,0,1-4.338,3.238,22.1,22.1,0,0,1-5.124,2.012A21.305,21.305,0,0,1,156,66.4a17.853,17.853,0,0,1-8.424-2.012,22.464,22.464,0,0,1-6.633-5.249,24.018,24.018,0,0,1-4.338-7.356,23.755,23.755,0,0,1-1.54-8.393",
    transform: "translate(-17.131 -2.681)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    className: "cls-3",
    d: "M200.273,68.324A16.1,16.1,0,0,1,188.3,63.231a16.664,16.664,0,0,1-3.363-5.407,17.751,17.751,0,0,1-1.194-6.475,17.522,17.522,0,0,1,1.226-6.538A17.143,17.143,0,0,1,188.36,39.4a16.468,16.468,0,0,1,23.89,0,17.143,17.143,0,0,1,3.395,5.407,17.522,17.522,0,0,1,1.226,6.538,17.769,17.769,0,0,1-1.195,6.475,16.324,16.324,0,0,1-8.644,9.116,16.186,16.186,0,0,1-6.758,1.383M189.4,51.412a13.162,13.162,0,0,0,.849,4.778,12.2,12.2,0,0,0,2.326,3.835A10.97,10.97,0,0,0,196.03,62.6a10.02,10.02,0,0,0,8.487,0,11.125,11.125,0,0,0,3.489-2.609,12.192,12.192,0,0,0,2.358-3.9,13.411,13.411,0,0,0,.849-4.809,13.247,13.247,0,0,0-.849-4.747,12.221,12.221,0,0,0-2.358-3.9,11.139,11.139,0,0,0-3.489-2.609,9.745,9.745,0,0,0-4.244-.943,9.483,9.483,0,0,0-4.244.974,11.2,11.2,0,0,0-3.458,2.64,12.524,12.524,0,0,0-2.326,3.9,13.418,13.418,0,0,0-.849,4.809",
    transform: "translate(-23.304 -4.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    className: "cls-3",
    d: "M246.522,39.764A14.237,14.237,0,0,0,239.2,41.9a10.906,10.906,0,0,0-4.5,5.6V67.741H229.17V34.923h5.155v7.607a16.711,16.711,0,0,1,4.464-5.627,9.253,9.253,0,0,1,5.91-2.232h1.069a3.989,3.989,0,0,1,.754.063Z",
    transform: "translate(-29.066 -4.397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    className: "cls-3",
    d: "M272.586,39.764a14.237,14.237,0,0,0-7.324,2.138,10.906,10.906,0,0,0-4.5,5.6V67.741h-5.532V34.923h5.155v7.607a16.711,16.711,0,0,1,4.464-5.627,9.253,9.253,0,0,1,5.91-2.232h1.069a3.989,3.989,0,0,1,.754.063Z",
    transform: "translate(-32.371 -4.397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    className: "cls-3",
    d: "M295.646,68.324a16.712,16.712,0,0,1-6.79-1.352,16.047,16.047,0,0,1-5.281-3.678,16.743,16.743,0,0,1-3.426-5.438,17.762,17.762,0,0,1-1.226-6.57,17.522,17.522,0,0,1,1.226-6.538A16.435,16.435,0,0,1,295.71,34.312a15.959,15.959,0,0,1,15.246,10.4,17.608,17.608,0,0,1,1.163,6.318c0,.462-.011.88-.032,1.257a6.784,6.784,0,0,1-.094.88H284.77a12.727,12.727,0,0,0,1.132,4.464,11.474,11.474,0,0,0,2.452,3.458,11.3,11.3,0,0,0,3.427,2.263,10.221,10.221,0,0,0,4.054.817,10.784,10.784,0,0,0,2.955-.409,12.823,12.823,0,0,0,2.7-1.1,9.41,9.41,0,0,0,2.231-1.7A6.94,6.94,0,0,0,305.2,58.7l4.777,1.32a12.071,12.071,0,0,1-2.232,3.332,14.771,14.771,0,0,1-3.268,2.609,16.872,16.872,0,0,1-4.119,1.729,17.536,17.536,0,0,1-4.715.629M306.9,49.086a11.83,11.83,0,0,0-1.163-4.306,11.528,11.528,0,0,0-2.452-3.363,11.239,11.239,0,0,0-11.724-2.169,10.675,10.675,0,0,0-3.427,2.2,11.146,11.146,0,0,0-2.389,3.363,12.367,12.367,0,0,0-1.1,4.275Z",
    transform: "translate(-35.376 -4.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    className: "cls-3",
    d: "M321.473,51.224a17.925,17.925,0,0,1,1.194-6.538,16.05,16.05,0,0,1,3.395-5.375,16.368,16.368,0,0,1,5.25-3.646,16.647,16.647,0,0,1,6.82-1.352,15.917,15.917,0,0,1,8.457,2.169,14.1,14.1,0,0,1,5.374,5.815l-5.406,1.7a9,9,0,0,0-3.521-3.615,9.992,9.992,0,0,0-5.029-1.289,10.28,10.28,0,0,0-7.734,3.458,12.548,12.548,0,0,0-2.295,3.835,13.368,13.368,0,0,0-.849,4.841,13.216,13.216,0,0,0,.88,4.841,12.908,12.908,0,0,0,2.358,3.929,10.76,10.76,0,0,0,3.458,2.609,9.745,9.745,0,0,0,4.244.943,10.226,10.226,0,0,0,2.861-.409,10.945,10.945,0,0,0,2.578-1.1,9.761,9.761,0,0,0,2.043-1.6,5.454,5.454,0,0,0,1.258-1.98l5.406,1.635a11.631,11.631,0,0,1-2.106,3.332A13.168,13.168,0,0,1,346.935,66a17.385,17.385,0,0,1-8.739,2.326,16.382,16.382,0,0,1-12.071-5.092,16.742,16.742,0,0,1-3.426-5.438,17.762,17.762,0,0,1-1.226-6.57",
    transform: "translate(-40.772 -4.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    className: "cls-3",
    d: "M380.363,64.554q-.5.251-1.321.6t-1.855.692a16.321,16.321,0,0,1-2.263.566,14.383,14.383,0,0,1-2.546.22,8.4,8.4,0,0,1-5.217-1.666,6.082,6.082,0,0,1-2.2-5.187V37.709H360.5V33.371h4.464V22.432h5.532V33.371h7.356v4.338h-7.356V58.078a3.428,3.428,0,0,0,1.195,2.64,4.021,4.021,0,0,0,2.515.817A8.056,8.056,0,0,0,377.188,61a12.756,12.756,0,0,0,1.855-.849Z",
    transform: "translate(-45.722 -2.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    className: "cls-4",
    d: "M420.173,61.031v5.029h-30.3V21.424h29.737v5.029H395.528v14.46h20.936v4.715H395.528v15.4Z",
    transform: "translate(-49.447 -2.717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    className: "cls-4",
    d: "M460.9,67.7h-5.532V49.338q0-5.281-1.6-7.67a5.468,5.468,0,0,0-4.872-2.389,9.307,9.307,0,0,0-3.395.66,13.455,13.455,0,0,0-3.206,1.792,12.459,12.459,0,0,0-2.641,2.7,11.568,11.568,0,0,0-1.7,3.458V67.7h-5.532V34.878h5.029v7.041a14.433,14.433,0,0,1,5.627-5.532,16.039,16.039,0,0,1,8.016-2.075,9.69,9.69,0,0,1,4.715,1.037,8,8,0,0,1,3.018,2.892,12.882,12.882,0,0,1,1.6,4.369,29.712,29.712,0,0,1,.472,5.47Z",
    transform: "translate(-54.844 -4.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    className: "cls-4",
    d: "M487.461,68.072a13.636,13.636,0,0,1-6.13-1.383,15.157,15.157,0,0,1-4.809-3.709,16.948,16.948,0,0,1-3.112-5.344,18.212,18.212,0,0,1-1.1-6.287,19.568,19.568,0,0,1,1.1-6.57,16.739,16.739,0,0,1,3.112-5.438,14.808,14.808,0,0,1,4.809-3.678,14.044,14.044,0,0,1,6.193-1.352,12.618,12.618,0,0,1,7.167,2.012,18.429,18.429,0,0,1,5.092,5.092V34.878h4.9v32.44a13.814,13.814,0,0,1-1.32,6.193,13.213,13.213,0,0,1-3.583,4.5,15.818,15.818,0,0,1-5.312,2.766,21.915,21.915,0,0,1-6.507.943,18.785,18.785,0,0,1-9.084-1.917,16.778,16.778,0,0,1-5.816-5.312l3.206-2.829a12.262,12.262,0,0,0,5.029,4.338,15.5,15.5,0,0,0,6.664,1.446,14.591,14.591,0,0,0,4.306-.629,10.153,10.153,0,0,0,3.552-1.886,9.3,9.3,0,0,0,2.42-3.143,10.161,10.161,0,0,0,.912-4.464V61.534a14.161,14.161,0,0,1-5.029,4.809,13.289,13.289,0,0,1-3.206,1.289,13.768,13.768,0,0,1-3.458.44m1.7-4.527a9.377,9.377,0,0,0,3.395-.629,12.425,12.425,0,0,0,3.018-1.666,10.793,10.793,0,0,0,2.326-2.358,7.516,7.516,0,0,0,1.257-2.7V46.76a12.537,12.537,0,0,0-1.792-3.081,13.621,13.621,0,0,0-2.483-2.42,11.121,11.121,0,0,0-2.986-1.6,9.667,9.667,0,0,0-3.238-.566,9.313,9.313,0,0,0-4.5,1.069,10.7,10.7,0,0,0-3.363,2.829,13.285,13.285,0,0,0-2.138,3.992,13.957,13.957,0,0,0-.754,4.5,12.571,12.571,0,0,0,3.269,8.487,11.529,11.529,0,0,0,3.552,2.609,10.145,10.145,0,0,0,4.432.974",
    transform: "translate(-59.903 -4.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    className: "cls-4",
    d: "M519.469,19.984H525V57.391a4.007,4.007,0,0,0,.974,2.861,3.567,3.567,0,0,0,2.735,1.037,7.3,7.3,0,0,0,1.635-.22,13.225,13.225,0,0,0,1.76-.534L532.985,65a18,18,0,0,1-3.269.943,17.227,17.227,0,0,1-3.331.377,6.9,6.9,0,0,1-5.061-1.823,6.812,6.812,0,0,1-1.855-5.092Z",
    transform: "translate(-65.884 -2.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    className: "cls-4",
    d: "M539.485,19.984h5.532V26.9h-5.532Zm0,13.077h5.532V65.878h-5.532Z",
    transform: "translate(-68.423 -2.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    className: "cls-4",
    d: "M566.986,68.324a25.453,25.453,0,0,1-7.8-1.226,19.215,19.215,0,0,1-6.6-3.552l2.389-3.709a23.227,23.227,0,0,0,5.784,3.3,17,17,0,0,0,6.1,1.1,10.075,10.075,0,0,0,5.69-1.415,4.536,4.536,0,0,0,2.106-3.992,3.6,3.6,0,0,0-.566-2.043,4.761,4.761,0,0,0-1.7-1.477,13.962,13.962,0,0,0-2.892-1.132q-1.762-.5-4.086-1.069-2.956-.754-5.092-1.446a13.779,13.779,0,0,1-3.521-1.635,5.711,5.711,0,0,1-2.012-2.263,7.58,7.58,0,0,1-.629-3.269,9.51,9.51,0,0,1,.974-4.369,9.212,9.212,0,0,1,2.672-3.206,12.043,12.043,0,0,1,3.992-1.949,17.781,17.781,0,0,1,4.935-.66,19.652,19.652,0,0,1,6.916,1.194,17.011,17.011,0,0,1,5.407,3.143l-2.515,3.332a14.121,14.121,0,0,0-4.652-2.735,15.736,15.736,0,0,0-5.281-.912,9.638,9.638,0,0,0-5.124,1.289,4.465,4.465,0,0,0-2.106,4.118,3.915,3.915,0,0,0,.409,1.886,3.554,3.554,0,0,0,1.352,1.32,10.625,10.625,0,0,0,2.42,1.006q1.476.44,3.552.943,3.269.754,5.69,1.54a16.424,16.424,0,0,1,4.023,1.855,7.167,7.167,0,0,1,2.389,2.515A7.286,7.286,0,0,1,580,58.328a8.715,8.715,0,0,1-3.521,7.293q-3.521,2.7-9.493,2.7",
    transform: "translate(-70.085 -4.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    className: "cls-4",
    d: "M619.732,65.878H614.2V47.52q0-5.092-1.76-7.576a5.919,5.919,0,0,0-5.155-2.483,8.669,8.669,0,0,0-3.269.66,12.12,12.12,0,0,0-3.049,1.792,12.923,12.923,0,0,0-2.515,2.7,12.007,12.007,0,0,0-1.666,3.458v19.8h-5.532V19.984h5.532V40.1a14.456,14.456,0,0,1,5.281-5.6,13.847,13.847,0,0,1,7.293-2.012,10.345,10.345,0,0,1,4.9,1.069,8.574,8.574,0,0,1,3.206,2.892,12.673,12.673,0,0,1,1.729,4.369,26.515,26.515,0,0,1,.534,5.438Z",
    transform: "translate(-74.988 -2.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M91.124,47.061A44.061,44.061,0,1,1,47.062,3,44.062,44.062,0,0,1,91.124,47.061",
    transform: "translate(-0.381 -0.38)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1796",
    "data-name": "Group 1796",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1795",
    "data-name": "Group 1795",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    className: "cls-6",
    d: "M0,106.923H0Z",
    transform: "translate(0 -13.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1843",
    "data-name": "Rectangle 1843",
    className: "cls-6",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 93.206)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1844",
    "data-name": "Rectangle 1844",
    className: "cls-7",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 93.048)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1845",
    "data-name": "Rectangle 1845",
    className: "cls-8",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 92.89)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1846",
    "data-name": "Rectangle 1846",
    className: "cls-9",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 92.733)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1847",
    "data-name": "Rectangle 1847",
    className: "cls-10",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 92.575)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1848",
    "data-name": "Rectangle 1848",
    className: "cls-11",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 92.418)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1849",
    "data-name": "Rectangle 1849",
    className: "cls-12",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 92.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1850",
    "data-name": "Rectangle 1850",
    className: "cls-13",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 92.103)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1851",
    "data-name": "Rectangle 1851",
    className: "cls-14",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 91.946)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1852",
    "data-name": "Rectangle 1852",
    className: "cls-15",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 91.788)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1853",
    "data-name": "Rectangle 1853",
    className: "cls-16",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 91.631)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1854",
    "data-name": "Rectangle 1854",
    className: "cls-17",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 91.473)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1855",
    "data-name": "Rectangle 1855",
    className: "cls-18",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 91.315)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1856",
    "data-name": "Rectangle 1856",
    className: "cls-19",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 91.158)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1857",
    "data-name": "Rectangle 1857",
    className: "cls-20",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 91)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1858",
    "data-name": "Rectangle 1858",
    className: "cls-21",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 90.843)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1859",
    "data-name": "Rectangle 1859",
    className: "cls-22",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 90.686)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1860",
    "data-name": "Rectangle 1860",
    className: "cls-23",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 90.528)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1861",
    "data-name": "Rectangle 1861",
    className: "cls-24",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 90.371)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1862",
    "data-name": "Rectangle 1862",
    className: "cls-25",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 90.213)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1863",
    "data-name": "Rectangle 1863",
    className: "cls-26",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 90.055)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1864",
    "data-name": "Rectangle 1864",
    className: "cls-27",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 89.898)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1865",
    "data-name": "Rectangle 1865",
    className: "cls-28",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 89.741)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1866",
    "data-name": "Rectangle 1866",
    className: "cls-29",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 89.583)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1867",
    "data-name": "Rectangle 1867",
    className: "cls-30",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 89.426)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1868",
    "data-name": "Rectangle 1868",
    className: "cls-31",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 89.268)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1869",
    "data-name": "Rectangle 1869",
    className: "cls-32",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 89.111)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1870",
    "data-name": "Rectangle 1870",
    className: "cls-33",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 88.953)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1871",
    "data-name": "Rectangle 1871",
    className: "cls-34",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 88.795)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1872",
    "data-name": "Rectangle 1872",
    className: "cls-35",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 88.638)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1873",
    "data-name": "Rectangle 1873",
    className: "cls-36",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 88.481)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1874",
    "data-name": "Rectangle 1874",
    className: "cls-37",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 88.323)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1875",
    "data-name": "Rectangle 1875",
    className: "cls-38",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 88.166)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1876",
    "data-name": "Rectangle 1876",
    className: "cls-39",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 88.008)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1877",
    "data-name": "Rectangle 1877",
    className: "cls-40",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 87.851)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1878",
    "data-name": "Rectangle 1878",
    className: "cls-41",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 87.693)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1879",
    "data-name": "Rectangle 1879",
    className: "cls-42",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 87.535)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1880",
    "data-name": "Rectangle 1880",
    className: "cls-43",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 87.378)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1881",
    "data-name": "Rectangle 1881",
    className: "cls-44",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 87.221)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1882",
    "data-name": "Rectangle 1882",
    className: "cls-45",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 87.063)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1883",
    "data-name": "Rectangle 1883",
    className: "cls-46",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 86.906)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1884",
    "data-name": "Rectangle 1884",
    className: "cls-47",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 86.748)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1885",
    "data-name": "Rectangle 1885",
    className: "cls-48",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 86.591)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1886",
    "data-name": "Rectangle 1886",
    className: "cls-49",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 86.433)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1887",
    "data-name": "Rectangle 1887",
    className: "cls-50",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 86.275)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1888",
    "data-name": "Rectangle 1888",
    className: "cls-51",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 86.118)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1889",
    "data-name": "Rectangle 1889",
    className: "cls-52",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 85.961)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1890",
    "data-name": "Rectangle 1890",
    className: "cls-53",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 85.803)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1891",
    "data-name": "Rectangle 1891",
    className: "cls-54",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 85.646)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1892",
    "data-name": "Rectangle 1892",
    className: "cls-55",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 85.489)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1893",
    "data-name": "Rectangle 1893",
    className: "cls-56",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 85.331)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1894",
    "data-name": "Rectangle 1894",
    className: "cls-57",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 85.173)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1895",
    "data-name": "Rectangle 1895",
    className: "cls-58",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 85.015)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1896",
    "data-name": "Rectangle 1896",
    className: "cls-59",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 84.858)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1897",
    "data-name": "Rectangle 1897",
    className: "cls-60",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 84.701)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1898",
    "data-name": "Rectangle 1898",
    className: "cls-61",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 84.543)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1899",
    "data-name": "Rectangle 1899",
    className: "cls-62",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 84.386)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1900",
    "data-name": "Rectangle 1900",
    className: "cls-63",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 84.229)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1901",
    "data-name": "Rectangle 1901",
    className: "cls-64",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 84.071)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1902",
    "data-name": "Rectangle 1902",
    className: "cls-65",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 83.913)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1903",
    "data-name": "Rectangle 1903",
    className: "cls-66",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 83.755)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1904",
    "data-name": "Rectangle 1904",
    className: "cls-67",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 83.598)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1905",
    "data-name": "Rectangle 1905",
    className: "cls-68",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 83.441)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1906",
    "data-name": "Rectangle 1906",
    className: "cls-69",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 83.283)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1907",
    "data-name": "Rectangle 1907",
    className: "cls-70",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 83.126)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1908",
    "data-name": "Rectangle 1908",
    className: "cls-71",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 82.969)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1909",
    "data-name": "Rectangle 1909",
    className: "cls-72",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 82.811)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1910",
    "data-name": "Rectangle 1910",
    className: "cls-73",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 82.653)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1911",
    "data-name": "Rectangle 1911",
    className: "cls-74",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 82.496)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1912",
    "data-name": "Rectangle 1912",
    className: "cls-75",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 82.338)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1913",
    "data-name": "Rectangle 1913",
    className: "cls-76",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 82.181)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1914",
    "data-name": "Rectangle 1914",
    className: "cls-77",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 82.023)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1915",
    "data-name": "Rectangle 1915",
    className: "cls-78",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 81.866)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1916",
    "data-name": "Rectangle 1916",
    className: "cls-79",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 81.709)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1917",
    "data-name": "Rectangle 1917",
    className: "cls-80",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 81.551)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1918",
    "data-name": "Rectangle 1918",
    className: "cls-81",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 81.393)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1919",
    "data-name": "Rectangle 1919",
    className: "cls-82",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 81.236)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1920",
    "data-name": "Rectangle 1920",
    className: "cls-83",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 81.078)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1921",
    "data-name": "Rectangle 1921",
    className: "cls-84",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 80.921)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1922",
    "data-name": "Rectangle 1922",
    className: "cls-85",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 80.763)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1923",
    "data-name": "Rectangle 1923",
    className: "cls-86",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 80.606)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1924",
    "data-name": "Rectangle 1924",
    className: "cls-87",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 80.449)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1925",
    "data-name": "Rectangle 1925",
    className: "cls-88",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 80.291)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1926",
    "data-name": "Rectangle 1926",
    className: "cls-89",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 80.133)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1927",
    "data-name": "Rectangle 1927",
    className: "cls-90",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 79.976)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1928",
    "data-name": "Rectangle 1928",
    className: "cls-91",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 79.818)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1929",
    "data-name": "Rectangle 1929",
    className: "cls-92",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 79.661)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1930",
    "data-name": "Rectangle 1930",
    className: "cls-93",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 79.503)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1931",
    "data-name": "Rectangle 1931",
    className: "cls-94",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 79.346)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1932",
    "data-name": "Rectangle 1932",
    className: "cls-95",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 79.189)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1933",
    "data-name": "Rectangle 1933",
    className: "cls-96",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 79.031)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1934",
    "data-name": "Rectangle 1934",
    className: "cls-97",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 78.873)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1935",
    "data-name": "Rectangle 1935",
    className: "cls-98",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 78.716)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1936",
    "data-name": "Rectangle 1936",
    className: "cls-99",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 78.558)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1937",
    "data-name": "Rectangle 1937",
    className: "cls-100",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 78.401)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1938",
    "data-name": "Rectangle 1938",
    className: "cls-101",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 78.244)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1939",
    "data-name": "Rectangle 1939",
    className: "cls-102",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 78.086)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1940",
    "data-name": "Rectangle 1940",
    className: "cls-103",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 77.929)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1941",
    "data-name": "Rectangle 1941",
    className: "cls-104",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 77.771)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1942",
    "data-name": "Rectangle 1942",
    className: "cls-105",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 77.613)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1943",
    "data-name": "Rectangle 1943",
    className: "cls-106",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 77.456)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1944",
    "data-name": "Rectangle 1944",
    className: "cls-107",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 77.298)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1945",
    "data-name": "Rectangle 1945",
    className: "cls-108",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 77.141)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1946",
    "data-name": "Rectangle 1946",
    className: "cls-109",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 76.984)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1947",
    "data-name": "Rectangle 1947",
    className: "cls-110",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 76.826)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1948",
    "data-name": "Rectangle 1948",
    className: "cls-111",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 76.669)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1949",
    "data-name": "Rectangle 1949",
    className: "cls-112",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 76.511)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1950",
    "data-name": "Rectangle 1950",
    className: "cls-113",
    width: 93.363,
    height: 0.157,
    transform: "translate(0 76.354)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1951",
    "data-name": "Rectangle 1951",
    className: "cls-113",
    width: 93.363,
    height: 1.811,
    transform: "translate(0 74.543)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1952",
    "data-name": "Rectangle 1952",
    className: "cls-112",
    width: 93.363,
    height: 1.811,
    transform: "translate(0 72.731)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1953",
    "data-name": "Rectangle 1953",
    className: "cls-111",
    width: 93.363,
    height: 1.811,
    transform: "translate(0 70.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1954",
    "data-name": "Rectangle 1954",
    className: "cls-110",
    width: 93.363,
    height: 1.811,
    transform: "translate(0 69.108)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1955",
    "data-name": "Rectangle 1955",
    className: "cls-109",
    width: 93.363,
    height: 1.811,
    transform: "translate(0 67.297)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1956",
    "data-name": "Rectangle 1956",
    className: "cls-107",
    width: 93.363,
    height: 1.811,
    transform: "translate(0 65.485)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1957",
    "data-name": "Rectangle 1957",
    className: "cls-106",
    width: 93.363,
    height: 1.811,
    transform: "translate(0 63.674)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1958",
    "data-name": "Rectangle 1958",
    className: "cls-105",
    width: 93.363,
    height: 1.811,
    transform: "translate(0 61.862)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1959",
    "data-name": "Rectangle 1959",
    className: "cls-104",
    width: 93.363,
    height: 1.811,
    transform: "translate(0 60.051)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1960",
    "data-name": "Rectangle 1960",
    className: "cls-103",
    width: 93.363,
    height: 1.811,
    transform: "translate(0 58.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1961",
    "data-name": "Rectangle 1961",
    className: "cls-102",
    width: 93.363,
    height: 1.811,
    transform: "translate(0 56.429)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1962",
    "data-name": "Rectangle 1962",
    className: "cls-102",
    width: 93.363,
    height: 1.896,
    transform: "translate(0 54.533)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1963",
    "data-name": "Rectangle 1963",
    className: "cls-101",
    width: 93.363,
    height: 1.896,
    transform: "translate(0 52.637)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1964",
    "data-name": "Rectangle 1964",
    className: "cls-100",
    width: 93.363,
    height: 1.896,
    transform: "translate(0 50.742)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1965",
    "data-name": "Rectangle 1965",
    className: "cls-114",
    width: 93.363,
    height: 1.896,
    transform: "translate(0 48.846)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1966",
    "data-name": "Rectangle 1966",
    className: "cls-97",
    width: 93.363,
    height: 1.896,
    transform: "translate(0 46.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1967",
    "data-name": "Rectangle 1967",
    className: "cls-96",
    width: 93.363,
    height: 1.896,
    transform: "translate(0 45.055)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1968",
    "data-name": "Rectangle 1968",
    className: "cls-95",
    width: 93.363,
    height: 1.896,
    transform: "translate(0 43.159)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1969",
    "data-name": "Rectangle 1969",
    className: "cls-94",
    width: 93.363,
    height: 1.896,
    transform: "translate(0 41.263)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1970",
    "data-name": "Rectangle 1970",
    className: "cls-94",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 41.044)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1971",
    "data-name": "Rectangle 1971",
    className: "cls-93",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 40.824)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1972",
    "data-name": "Rectangle 1972",
    className: "cls-92",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 40.605)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1973",
    "data-name": "Rectangle 1973",
    className: "cls-91",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 40.385)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1974",
    "data-name": "Rectangle 1974",
    className: "cls-90",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 40.166)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1975",
    "data-name": "Rectangle 1975",
    className: "cls-89",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 39.946)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1976",
    "data-name": "Rectangle 1976",
    className: "cls-88",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 39.727)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1977",
    "data-name": "Rectangle 1977",
    className: "cls-87",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 39.507)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1978",
    "data-name": "Rectangle 1978",
    className: "cls-86",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 39.287)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1979",
    "data-name": "Rectangle 1979",
    className: "cls-85",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 39.068)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1980",
    "data-name": "Rectangle 1980",
    className: "cls-84",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 38.848)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1981",
    "data-name": "Rectangle 1981",
    className: "cls-83",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 38.629)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1982",
    "data-name": "Rectangle 1982",
    className: "cls-82",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 38.409)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1983",
    "data-name": "Rectangle 1983",
    className: "cls-81",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 38.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1984",
    "data-name": "Rectangle 1984",
    className: "cls-80",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 37.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1985",
    "data-name": "Rectangle 1985",
    className: "cls-79",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 37.751)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1986",
    "data-name": "Rectangle 1986",
    className: "cls-78",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 37.531)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1987",
    "data-name": "Rectangle 1987",
    className: "cls-77",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 37.311)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1988",
    "data-name": "Rectangle 1988",
    className: "cls-76",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 37.092)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1989",
    "data-name": "Rectangle 1989",
    className: "cls-75",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 36.872)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1990",
    "data-name": "Rectangle 1990",
    className: "cls-74",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 36.653)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1991",
    "data-name": "Rectangle 1991",
    className: "cls-73",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 36.433)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1992",
    "data-name": "Rectangle 1992",
    className: "cls-115",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 36.214)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1993",
    "data-name": "Rectangle 1993",
    className: "cls-116",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 35.994)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1994",
    "data-name": "Rectangle 1994",
    className: "cls-117",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 35.775)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1995",
    "data-name": "Rectangle 1995",
    className: "cls-118",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 35.555)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1996",
    "data-name": "Rectangle 1996",
    className: "cls-119",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 35.335)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1997",
    "data-name": "Rectangle 1997",
    className: "cls-120",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 35.115)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1998",
    "data-name": "Rectangle 1998",
    className: "cls-121",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 34.896)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1999",
    "data-name": "Rectangle 1999",
    className: "cls-122",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 34.677)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2000",
    "data-name": "Rectangle 2000",
    className: "cls-123",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 34.457)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2001",
    "data-name": "Rectangle 2001",
    className: "cls-124",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 34.238)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2002",
    "data-name": "Rectangle 2002",
    className: "cls-125",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 34.018)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2003",
    "data-name": "Rectangle 2003",
    className: "cls-126",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 33.799)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2004",
    "data-name": "Rectangle 2004",
    className: "cls-127",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 33.579)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2005",
    "data-name": "Rectangle 2005",
    className: "cls-128",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 33.359)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2006",
    "data-name": "Rectangle 2006",
    className: "cls-129",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 33.139)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2007",
    "data-name": "Rectangle 2007",
    className: "cls-130",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 32.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2008",
    "data-name": "Rectangle 2008",
    className: "cls-131",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 32.701)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2009",
    "data-name": "Rectangle 2009",
    className: "cls-132",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 32.481)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2010",
    "data-name": "Rectangle 2010",
    className: "cls-133",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 32.262)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2011",
    "data-name": "Rectangle 2011",
    className: "cls-134",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 32.042)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2012",
    "data-name": "Rectangle 2012",
    className: "cls-135",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 31.823)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2013",
    "data-name": "Rectangle 2013",
    className: "cls-136",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 31.603)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2014",
    "data-name": "Rectangle 2014",
    className: "cls-137",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 31.383)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2015",
    "data-name": "Rectangle 2015",
    className: "cls-138",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 31.163)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2016",
    "data-name": "Rectangle 2016",
    className: "cls-139",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 30.944)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2017",
    "data-name": "Rectangle 2017",
    className: "cls-140",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 30.724)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2018",
    "data-name": "Rectangle 2018",
    className: "cls-141",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 30.505)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2019",
    "data-name": "Rectangle 2019",
    className: "cls-142",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 30.286)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2020",
    "data-name": "Rectangle 2020",
    className: "cls-143",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 30.066)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2021",
    "data-name": "Rectangle 2021",
    className: "cls-144",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 29.847)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2022",
    "data-name": "Rectangle 2022",
    className: "cls-145",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 29.627)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2023",
    "data-name": "Rectangle 2023",
    className: "cls-146",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 29.408)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2024",
    "data-name": "Rectangle 2024",
    className: "cls-147",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 29.187)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2025",
    "data-name": "Rectangle 2025",
    className: "cls-148",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 28.968)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2026",
    "data-name": "Rectangle 2026",
    className: "cls-149",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 28.748)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2027",
    "data-name": "Rectangle 2027",
    className: "cls-150",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 28.529)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2028",
    "data-name": "Rectangle 2028",
    className: "cls-151",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 28.309)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2029",
    "data-name": "Rectangle 2029",
    className: "cls-152",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 28.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2030",
    "data-name": "Rectangle 2030",
    className: "cls-153",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 27.871)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2031",
    "data-name": "Rectangle 2031",
    className: "cls-154",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 27.651)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2032",
    "data-name": "Rectangle 2032",
    className: "cls-155",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 27.432)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2033",
    "data-name": "Rectangle 2033",
    className: "cls-156",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 27.211)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2034",
    "data-name": "Rectangle 2034",
    className: "cls-157",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 26.992)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2035",
    "data-name": "Rectangle 2035",
    className: "cls-158",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 26.772)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2036",
    "data-name": "Rectangle 2036",
    className: "cls-159",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 26.553)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2037",
    "data-name": "Rectangle 2037",
    className: "cls-160",
    width: 93.363,
    height: 0.219,
    transform: "translate(0 26.333)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2038",
    "data-name": "Rectangle 2038",
    className: "cls-160",
    width: 93.363,
    height: 0.855,
    transform: "translate(0 25.478)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2039",
    "data-name": "Rectangle 2039",
    className: "cls-161",
    width: 93.363,
    height: 0.855,
    transform: "translate(0 24.623)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2040",
    "data-name": "Rectangle 2040",
    className: "cls-162",
    width: 93.363,
    height: 0.855,
    transform: "translate(0 23.769)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2041",
    "data-name": "Rectangle 2041",
    className: "cls-163",
    width: 93.363,
    height: 0.855,
    transform: "translate(0 22.914)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2042",
    "data-name": "Rectangle 2042",
    className: "cls-164",
    width: 93.363,
    height: 0.855,
    transform: "translate(0 22.059)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2043",
    "data-name": "Rectangle 2043",
    className: "cls-165",
    width: 93.363,
    height: 0.855,
    transform: "translate(0 21.203)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2044",
    "data-name": "Rectangle 2044",
    className: "cls-166",
    width: 93.363,
    height: 0.855,
    transform: "translate(0 20.348)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2045",
    "data-name": "Rectangle 2045",
    className: "cls-19",
    width: 93.363,
    height: 0.855,
    transform: "translate(0 19.494)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2046",
    "data-name": "Rectangle 2046",
    className: "cls-19",
    width: 93.363,
    height: 19.494,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2047",
    "data-name": "Rectangle 2047",
    className: "cls-22",
    width: 88.124,
    height: 0.058,
    transform: "translate(2.62 90.686)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2048",
    "data-name": "Rectangle 2048",
    className: "cls-23",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 90.528)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2049",
    "data-name": "Rectangle 2049",
    className: "cls-24",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 90.371)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2050",
    "data-name": "Rectangle 2050",
    className: "cls-25",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 90.213)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2051",
    "data-name": "Rectangle 2051",
    className: "cls-26",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 90.055)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2052",
    "data-name": "Rectangle 2052",
    className: "cls-27",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 89.898)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2053",
    "data-name": "Rectangle 2053",
    className: "cls-28",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 89.741)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2054",
    "data-name": "Rectangle 2054",
    className: "cls-29",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 89.583)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2055",
    "data-name": "Rectangle 2055",
    className: "cls-30",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 89.426)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2056",
    "data-name": "Rectangle 2056",
    className: "cls-31",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 89.268)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2057",
    "data-name": "Rectangle 2057",
    className: "cls-32",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 89.111)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2058",
    "data-name": "Rectangle 2058",
    className: "cls-33",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 88.953)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2059",
    "data-name": "Rectangle 2059",
    className: "cls-34",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 88.795)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2060",
    "data-name": "Rectangle 2060",
    className: "cls-35",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 88.638)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2061",
    "data-name": "Rectangle 2061",
    className: "cls-36",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 88.481)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2062",
    "data-name": "Rectangle 2062",
    className: "cls-37",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 88.323)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2063",
    "data-name": "Rectangle 2063",
    className: "cls-38",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 88.166)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2064",
    "data-name": "Rectangle 2064",
    className: "cls-39",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 88.008)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2065",
    "data-name": "Rectangle 2065",
    className: "cls-40",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 87.851)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2066",
    "data-name": "Rectangle 2066",
    className: "cls-41",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 87.693)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2067",
    "data-name": "Rectangle 2067",
    className: "cls-42",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 87.535)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2068",
    "data-name": "Rectangle 2068",
    className: "cls-43",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 87.378)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2069",
    "data-name": "Rectangle 2069",
    className: "cls-44",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 87.221)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2070",
    "data-name": "Rectangle 2070",
    className: "cls-45",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 87.063)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2071",
    "data-name": "Rectangle 2071",
    className: "cls-46",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 86.906)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2072",
    "data-name": "Rectangle 2072",
    className: "cls-47",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 86.748)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2073",
    "data-name": "Rectangle 2073",
    className: "cls-48",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 86.591)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2074",
    "data-name": "Rectangle 2074",
    className: "cls-49",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 86.433)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2075",
    "data-name": "Rectangle 2075",
    className: "cls-50",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 86.275)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2076",
    "data-name": "Rectangle 2076",
    className: "cls-51",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 86.118)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2077",
    "data-name": "Rectangle 2077",
    className: "cls-52",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 85.961)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2078",
    "data-name": "Rectangle 2078",
    className: "cls-53",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 85.803)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2079",
    "data-name": "Rectangle 2079",
    className: "cls-54",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 85.646)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2080",
    "data-name": "Rectangle 2080",
    className: "cls-55",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 85.489)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2081",
    "data-name": "Rectangle 2081",
    className: "cls-56",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 85.331)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2082",
    "data-name": "Rectangle 2082",
    className: "cls-57",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 85.173)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2083",
    "data-name": "Rectangle 2083",
    className: "cls-58",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 85.015)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2084",
    "data-name": "Rectangle 2084",
    className: "cls-59",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 84.858)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2085",
    "data-name": "Rectangle 2085",
    className: "cls-60",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 84.701)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2086",
    "data-name": "Rectangle 2086",
    className: "cls-61",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 84.543)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2087",
    "data-name": "Rectangle 2087",
    className: "cls-62",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 84.386)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2088",
    "data-name": "Rectangle 2088",
    className: "cls-63",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 84.229)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2089",
    "data-name": "Rectangle 2089",
    className: "cls-64",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 84.071)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2090",
    "data-name": "Rectangle 2090",
    className: "cls-65",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 83.913)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2091",
    "data-name": "Rectangle 2091",
    className: "cls-66",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 83.755)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2092",
    "data-name": "Rectangle 2092",
    className: "cls-67",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 83.598)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2093",
    "data-name": "Rectangle 2093",
    className: "cls-68",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 83.441)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2094",
    "data-name": "Rectangle 2094",
    className: "cls-69",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 83.283)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2095",
    "data-name": "Rectangle 2095",
    className: "cls-70",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 83.126)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2096",
    "data-name": "Rectangle 2096",
    className: "cls-71",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 82.969)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2097",
    "data-name": "Rectangle 2097",
    className: "cls-72",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 82.811)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2098",
    "data-name": "Rectangle 2098",
    className: "cls-73",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 82.653)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2099",
    "data-name": "Rectangle 2099",
    className: "cls-74",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 82.496)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2100",
    "data-name": "Rectangle 2100",
    className: "cls-75",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 82.338)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2101",
    "data-name": "Rectangle 2101",
    className: "cls-76",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 82.181)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2102",
    "data-name": "Rectangle 2102",
    className: "cls-77",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 82.023)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2103",
    "data-name": "Rectangle 2103",
    className: "cls-78",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 81.866)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2104",
    "data-name": "Rectangle 2104",
    className: "cls-79",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 81.709)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2105",
    "data-name": "Rectangle 2105",
    className: "cls-80",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 81.551)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2106",
    "data-name": "Rectangle 2106",
    className: "cls-81",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 81.393)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2107",
    "data-name": "Rectangle 2107",
    className: "cls-82",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 81.236)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2108",
    "data-name": "Rectangle 2108",
    className: "cls-83",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 81.078)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2109",
    "data-name": "Rectangle 2109",
    className: "cls-84",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 80.921)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2110",
    "data-name": "Rectangle 2110",
    className: "cls-85",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 80.763)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2111",
    "data-name": "Rectangle 2111",
    className: "cls-86",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 80.606)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2112",
    "data-name": "Rectangle 2112",
    className: "cls-87",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 80.449)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2113",
    "data-name": "Rectangle 2113",
    className: "cls-88",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 80.291)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2114",
    "data-name": "Rectangle 2114",
    className: "cls-89",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 80.133)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2115",
    "data-name": "Rectangle 2115",
    className: "cls-90",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 79.976)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2116",
    "data-name": "Rectangle 2116",
    className: "cls-91",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 79.818)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2117",
    "data-name": "Rectangle 2117",
    className: "cls-92",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 79.661)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2118",
    "data-name": "Rectangle 2118",
    className: "cls-93",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 79.503)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2119",
    "data-name": "Rectangle 2119",
    className: "cls-94",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 79.346)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2120",
    "data-name": "Rectangle 2120",
    className: "cls-95",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 79.189)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2121",
    "data-name": "Rectangle 2121",
    className: "cls-96",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 79.031)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2122",
    "data-name": "Rectangle 2122",
    className: "cls-97",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 78.873)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2123",
    "data-name": "Rectangle 2123",
    className: "cls-98",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 78.716)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2124",
    "data-name": "Rectangle 2124",
    className: "cls-99",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 78.558)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2125",
    "data-name": "Rectangle 2125",
    className: "cls-100",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 78.401)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2126",
    "data-name": "Rectangle 2126",
    className: "cls-101",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 78.244)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2127",
    "data-name": "Rectangle 2127",
    className: "cls-102",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 78.086)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2128",
    "data-name": "Rectangle 2128",
    className: "cls-103",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 77.929)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2129",
    "data-name": "Rectangle 2129",
    className: "cls-104",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 77.771)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2130",
    "data-name": "Rectangle 2130",
    className: "cls-105",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 77.613)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2131",
    "data-name": "Rectangle 2131",
    className: "cls-106",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 77.456)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2132",
    "data-name": "Rectangle 2132",
    className: "cls-107",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 77.298)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2133",
    "data-name": "Rectangle 2133",
    className: "cls-108",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 77.141)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2134",
    "data-name": "Rectangle 2134",
    className: "cls-109",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 76.984)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2135",
    "data-name": "Rectangle 2135",
    className: "cls-110",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 76.826)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2136",
    "data-name": "Rectangle 2136",
    className: "cls-111",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 76.669)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2137",
    "data-name": "Rectangle 2137",
    className: "cls-112",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 76.511)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2138",
    "data-name": "Rectangle 2138",
    className: "cls-113",
    width: 88.124,
    height: 0.157,
    transform: "translate(2.62 76.354)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2139",
    "data-name": "Rectangle 2139",
    className: "cls-113",
    width: 88.124,
    height: 1.811,
    transform: "translate(2.62 74.543)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2140",
    "data-name": "Rectangle 2140",
    className: "cls-112",
    width: 88.124,
    height: 1.811,
    transform: "translate(2.62 72.731)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2141",
    "data-name": "Rectangle 2141",
    className: "cls-111",
    width: 88.124,
    height: 1.811,
    transform: "translate(2.62 70.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2142",
    "data-name": "Rectangle 2142",
    className: "cls-110",
    width: 88.124,
    height: 1.811,
    transform: "translate(2.62 69.108)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2143",
    "data-name": "Rectangle 2143",
    className: "cls-109",
    width: 88.124,
    height: 1.811,
    transform: "translate(2.62 67.297)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2144",
    "data-name": "Rectangle 2144",
    className: "cls-107",
    width: 88.124,
    height: 1.811,
    transform: "translate(2.62 65.485)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2145",
    "data-name": "Rectangle 2145",
    className: "cls-106",
    width: 88.124,
    height: 1.811,
    transform: "translate(2.62 63.674)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2146",
    "data-name": "Rectangle 2146",
    className: "cls-105",
    width: 88.124,
    height: 1.811,
    transform: "translate(2.62 61.862)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2147",
    "data-name": "Rectangle 2147",
    className: "cls-104",
    width: 88.124,
    height: 1.811,
    transform: "translate(2.62 60.051)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2148",
    "data-name": "Rectangle 2148",
    className: "cls-103",
    width: 88.124,
    height: 1.811,
    transform: "translate(2.62 58.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2149",
    "data-name": "Rectangle 2149",
    className: "cls-102",
    width: 88.124,
    height: 1.811,
    transform: "translate(2.62 56.429)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2150",
    "data-name": "Rectangle 2150",
    className: "cls-102",
    width: 88.124,
    height: 1.896,
    transform: "translate(2.62 54.533)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2151",
    "data-name": "Rectangle 2151",
    className: "cls-101",
    width: 88.124,
    height: 1.896,
    transform: "translate(2.62 52.637)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2152",
    "data-name": "Rectangle 2152",
    className: "cls-100",
    width: 88.124,
    height: 1.896,
    transform: "translate(2.62 50.742)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2153",
    "data-name": "Rectangle 2153",
    className: "cls-114",
    width: 88.124,
    height: 1.896,
    transform: "translate(2.62 48.846)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2154",
    "data-name": "Rectangle 2154",
    className: "cls-97",
    width: 88.124,
    height: 1.896,
    transform: "translate(2.62 46.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2155",
    "data-name": "Rectangle 2155",
    className: "cls-96",
    width: 88.124,
    height: 1.896,
    transform: "translate(2.62 45.055)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2156",
    "data-name": "Rectangle 2156",
    className: "cls-95",
    width: 88.124,
    height: 1.896,
    transform: "translate(2.62 43.159)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2157",
    "data-name": "Rectangle 2157",
    className: "cls-94",
    width: 88.124,
    height: 1.896,
    transform: "translate(2.62 41.263)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2158",
    "data-name": "Rectangle 2158",
    className: "cls-94",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 41.044)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2159",
    "data-name": "Rectangle 2159",
    className: "cls-93",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 40.824)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2160",
    "data-name": "Rectangle 2160",
    className: "cls-92",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 40.605)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2161",
    "data-name": "Rectangle 2161",
    className: "cls-91",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 40.385)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2162",
    "data-name": "Rectangle 2162",
    className: "cls-90",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 40.166)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2163",
    "data-name": "Rectangle 2163",
    className: "cls-89",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 39.946)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2164",
    "data-name": "Rectangle 2164",
    className: "cls-88",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 39.727)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2165",
    "data-name": "Rectangle 2165",
    className: "cls-87",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 39.507)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2166",
    "data-name": "Rectangle 2166",
    className: "cls-86",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 39.287)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2167",
    "data-name": "Rectangle 2167",
    className: "cls-85",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 39.068)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2168",
    "data-name": "Rectangle 2168",
    className: "cls-84",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 38.848)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2169",
    "data-name": "Rectangle 2169",
    className: "cls-83",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 38.629)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2170",
    "data-name": "Rectangle 2170",
    className: "cls-82",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 38.409)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2171",
    "data-name": "Rectangle 2171",
    className: "cls-81",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 38.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2172",
    "data-name": "Rectangle 2172",
    className: "cls-80",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 37.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2173",
    "data-name": "Rectangle 2173",
    className: "cls-79",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 37.751)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2174",
    "data-name": "Rectangle 2174",
    className: "cls-78",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 37.531)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2175",
    "data-name": "Rectangle 2175",
    className: "cls-77",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 37.311)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2176",
    "data-name": "Rectangle 2176",
    className: "cls-76",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 37.092)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2177",
    "data-name": "Rectangle 2177",
    className: "cls-75",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 36.872)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2178",
    "data-name": "Rectangle 2178",
    className: "cls-74",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 36.653)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2179",
    "data-name": "Rectangle 2179",
    className: "cls-73",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 36.433)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2180",
    "data-name": "Rectangle 2180",
    className: "cls-115",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 36.214)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2181",
    "data-name": "Rectangle 2181",
    className: "cls-116",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 35.994)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2182",
    "data-name": "Rectangle 2182",
    className: "cls-117",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 35.775)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2183",
    "data-name": "Rectangle 2183",
    className: "cls-118",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 35.555)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2184",
    "data-name": "Rectangle 2184",
    className: "cls-119",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 35.335)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2185",
    "data-name": "Rectangle 2185",
    className: "cls-120",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 35.115)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2186",
    "data-name": "Rectangle 2186",
    className: "cls-121",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 34.896)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2187",
    "data-name": "Rectangle 2187",
    className: "cls-122",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 34.677)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2188",
    "data-name": "Rectangle 2188",
    className: "cls-123",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 34.457)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2189",
    "data-name": "Rectangle 2189",
    className: "cls-124",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 34.238)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2190",
    "data-name": "Rectangle 2190",
    className: "cls-125",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 34.018)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2191",
    "data-name": "Rectangle 2191",
    className: "cls-126",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 33.799)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2192",
    "data-name": "Rectangle 2192",
    className: "cls-127",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 33.579)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2193",
    "data-name": "Rectangle 2193",
    className: "cls-128",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 33.359)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2194",
    "data-name": "Rectangle 2194",
    className: "cls-129",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 33.139)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2195",
    "data-name": "Rectangle 2195",
    className: "cls-130",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 32.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2196",
    "data-name": "Rectangle 2196",
    className: "cls-131",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 32.701)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2197",
    "data-name": "Rectangle 2197",
    className: "cls-132",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 32.481)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2198",
    "data-name": "Rectangle 2198",
    className: "cls-133",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 32.262)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2199",
    "data-name": "Rectangle 2199",
    className: "cls-134",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 32.042)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2200",
    "data-name": "Rectangle 2200",
    className: "cls-135",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 31.823)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2201",
    "data-name": "Rectangle 2201",
    className: "cls-136",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 31.603)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2202",
    "data-name": "Rectangle 2202",
    className: "cls-137",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 31.383)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2203",
    "data-name": "Rectangle 2203",
    className: "cls-138",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 31.163)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2204",
    "data-name": "Rectangle 2204",
    className: "cls-139",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 30.944)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2205",
    "data-name": "Rectangle 2205",
    className: "cls-140",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 30.724)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2206",
    "data-name": "Rectangle 2206",
    className: "cls-141",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 30.505)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2207",
    "data-name": "Rectangle 2207",
    className: "cls-142",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 30.286)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2208",
    "data-name": "Rectangle 2208",
    className: "cls-143",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 30.066)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2209",
    "data-name": "Rectangle 2209",
    className: "cls-144",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 29.847)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2210",
    "data-name": "Rectangle 2210",
    className: "cls-145",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 29.627)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2211",
    "data-name": "Rectangle 2211",
    className: "cls-146",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 29.408)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2212",
    "data-name": "Rectangle 2212",
    className: "cls-147",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 29.187)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2213",
    "data-name": "Rectangle 2213",
    className: "cls-148",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 28.968)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2214",
    "data-name": "Rectangle 2214",
    className: "cls-149",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 28.748)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2215",
    "data-name": "Rectangle 2215",
    className: "cls-150",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 28.529)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2216",
    "data-name": "Rectangle 2216",
    className: "cls-151",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 28.309)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2217",
    "data-name": "Rectangle 2217",
    className: "cls-152",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 28.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2218",
    "data-name": "Rectangle 2218",
    className: "cls-153",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 27.871)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2219",
    "data-name": "Rectangle 2219",
    className: "cls-154",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 27.651)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2220",
    "data-name": "Rectangle 2220",
    className: "cls-155",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 27.432)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2221",
    "data-name": "Rectangle 2221",
    className: "cls-156",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 27.211)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2222",
    "data-name": "Rectangle 2222",
    className: "cls-157",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 26.992)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2223",
    "data-name": "Rectangle 2223",
    className: "cls-158",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 26.772)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2224",
    "data-name": "Rectangle 2224",
    className: "cls-159",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 26.553)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2225",
    "data-name": "Rectangle 2225",
    className: "cls-160",
    width: 88.124,
    height: 0.219,
    transform: "translate(2.62 26.333)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2226",
    "data-name": "Rectangle 2226",
    className: "cls-160",
    width: 88.124,
    height: 0.855,
    transform: "translate(2.62 25.478)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2227",
    "data-name": "Rectangle 2227",
    className: "cls-161",
    width: 88.124,
    height: 0.855,
    transform: "translate(2.62 24.623)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2228",
    "data-name": "Rectangle 2228",
    className: "cls-162",
    width: 88.124,
    height: 0.855,
    transform: "translate(2.62 23.769)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2229",
    "data-name": "Rectangle 2229",
    className: "cls-163",
    width: 88.124,
    height: 0.855,
    transform: "translate(2.62 22.914)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2230",
    "data-name": "Rectangle 2230",
    className: "cls-164",
    width: 88.124,
    height: 0.855,
    transform: "translate(2.62 22.059)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2231",
    "data-name": "Rectangle 2231",
    className: "cls-165",
    width: 88.124,
    height: 0.855,
    transform: "translate(2.62 21.203)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2232",
    "data-name": "Rectangle 2232",
    className: "cls-166",
    width: 88.124,
    height: 0.855,
    transform: "translate(2.62 20.348)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2233",
    "data-name": "Rectangle 2233",
    className: "cls-19",
    width: 88.124,
    height: 0.855,
    transform: "translate(2.62 19.494)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2234",
    "data-name": "Rectangle 2234",
    className: "cls-19",
    width: 88.124,
    height: 16.874,
    transform: "translate(2.62 2.62)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1801",
    "data-name": "Group 1801",
    transform: "translate(29.052 68.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1800",
    "data-name": "Group 1800",
    className: "cls-167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1799",
    "data-name": "Group 1799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1798",
    "data-name": "Group 1798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1797",
    "data-name": "Group 1797",
    className: "cls-168"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2235",
    "data-name": "Rectangle 2235",
    width: 9.64,
    height: 14.25,
    transform: "translate(-0.133 -0.347)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAiCAIAAAA7/9XpAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFmSURBVEhLlZVbbsQgDEWd9LEtUqnbqtJpFzbTbfWHXjDhYWygR1aGSciJbRJBfp3HPQ06/mN5If9M/nb2umXL12eyPMV4c/5eXGsWPLxW7DE28kT+PHF9zfJ+SAsUbImiBYtIJFtYgVjKpU+ktjiHKTuN+XmEwPQaFjDHEY78PBORiFYOGFpyR+y+8sShZZrI9crYFnVptHKAbZkmcpUDDIvaEaMcYFisRLRygGbpE+ktVTlAs6iJ2OWAzrLSEURLZ1lJpC0HtJaVjiA62lNQTBOJH7Gg+qa/b+GIiQJxhj/ilg2mNHzdwpH/5TsxkGfyqHDlUidSbki/ZeBcGgi4MKUj3BTR1251mGjhXWLaV4RBvLCYiLY6DJXtSk2ktrRvfc0GRWxPdQR8Hw8y2uowO/16+jjD0JwTwdY1IOUEsI2LcqI5hV0O6NoOF3Zy0RHEEOMynny4ojBek8zkIeF+LPCwHO/9H6N5hRweNfStAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1806",
    "data-name": "Group 1806",
    transform: "translate(17.816 63.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1805",
    "data-name": "Group 1805",
    className: "cls-169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1804",
    "data-name": "Group 1804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1803",
    "data-name": "Group 1803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1802",
    "data-name": "Group 1802",
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2237",
    "data-name": "Rectangle 2237",
    width: 15.508,
    height: 15.508,
    transform: "translate(-0.213 -0.018)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAlCAIAAABK/LdUAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALjSURBVFhHpZY7chNBEIZn1xkgKBJeNwFjWxYJLleBcXEaEpTAPUgpigICFFmS8eMIpFyCmOHv/ufR+9Su9dWop7tXM7+6d1aS89tztfaPS396GMJettaj2CMdbzZLbqdHMeo9LP2D0p9skCzwcjfj7cxdnzuuhg2Od8+m7ttSgxbKMI+lS8wX7vLcvZ5p3MKN9LrEXKGeE8lX7ZLj9XoqY8hxuXb3S7FVxuhB5slOEEsDUEycmMFE/3jmLiqSg88LZFAZ4Nu5HR3anFExcTi8ez51P1eaGlhfp1isgyGoi8Er3MW5OzpkoQPq6xHDXjlkhk5KaqsZouWL5Sa92unIVjeAqSVTKAMvc4j2D9xi1dtPihEsyNZ8aglpe8VQ3Lv3uNitl8S4gE6w8TkDvEqxNATzgSi2NxW3vZ/btFEcbQAzYE86qV6zPsikhyxhd0n5lCSY7duYIdpJUtWDTPMopl3YxlrShsC+jcROEtNPiuWV1mKKlcHmpA31JaH5WHD//pMwEutLlZG8BayuS5nKJbUgX413FwNii/oPk9Znj2K/zWHsZAhhzW1jRh849TI780npPn8St7KYFpOpjIijYiRfVbEEot9/gm8o3dN9mfOyZDFVxWDFYZDnkGRI29ZJUsrP/5czce2C5j2jj8mGYjWoPQB44MyZtMTzeb12py/iLpgalYnVKWWaDi2kq2fSEs8nqvyaqhwgRpgUJ9ruThLzvFckI2EjndKmyYKa091J0vj+vFq7k9TYZKvHAVZWxXvGJOnuJGl8f+7i36NWSWSvhljC+qC3k6ShByD5/SzuFcVIkMTUeC43dZI0+pnAXzn+h7T7woZ7WW1m75m0tNVH8Kfqx9LtHohfEcPeUYwgGtDJAOrbwPHU3yv8XR0T5yeFv1P42zpuqX05De8cwAA98HGuYjoglvQ4xjBMD/xatYshP4bBeuRoWtEb00kyUg98mGe98YzXA+ghKoPwWLz/D+lUZ/NFcUQ1AAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1811",
    "data-name": "Group 1811",
    transform: "translate(10.499 55.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1810",
    "data-name": "Group 1810",
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1809",
    "data-name": "Group 1809",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1808",
    "data-name": "Group 1808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1807",
    "data-name": "Group 1807",
    className: "cls-172"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2239",
    "data-name": "Rectangle 2239",
    width: 15.508,
    height: 14.25,
    transform: "translate(-0.021 -0.338)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAiCAIAAABX+YfsAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAL9SURBVEhLrVbBbhQxDM1UavshgNRDBRLsLrfhAPwEEhIHVFARfEH3UvgBrl1VBan9iW4PbE9UCK4c4Et6aHi2E8fJZJZtO08ex3E8frWTZrbx3rvB8fOc9KOWJznANyQO9v14g2S0ETw5Bqpv9pFq+sVlST7onT23M+VJwu34hANkAmUS42HrZnO2Em7ERzQLN/tEtr6tZKqBg1M3ehJsxjX5qn0T2Knk9A0dmcOsxNX4wAEmoQGy1KyBMOUBTKRZDk/dOJW4lM/2DdBAMawGuk5oyKh1R6nEHr4lfQMyj6dqKEmsSXSK8cQXS8z5lAY+vK4rMExUtMEEDbI8MmkeoMat+3LGLuGr9k20oOLhsoJtlkIkD8Fm+Tp3EyqxwV3AboZGKApPSGSYRJcBbAN26fcl1BpZ4q2KrIqmXOieOXsq5EHFbIVpvnTl3ctnMNfc6z12FRFRrqB5n0ganlYFT+FRkc437uLcXSx4/0abIVo1QCliKQJ6ORoKZVINhCkGPk1kByf3ExedzNMannjwrMiqaMSQWI8VLst6gEnLfLjIZZ5SmNaRvxAexLarZHMGMkxvZPV47k7OmA9XqrjoL4pnDwhOKzJYT4wkjYEz6JLIpHUnc/eY/h+YD3ijJbIU54L8bJVOK3gMk6wC76coS8gAc7884FMD2GhAA5LHaMBOiyX0MDIJYn3AWy5RBQATifUYoWkeEJys0cM/lwUZkN+f9zfjO9FpUwiCLTRxs4uwTlkKUx+AEgEho3Q0pizJA7J4soowlNVPBuT1Adt8narP5gLIwMPnIkzNKo7Gh/IHUoEO34+Fe/WcjCJXCMuZAJ3GE78ceT8BfBjxucL7IoLQ4U5ZYqCHfytHo4oOH7BrekJbhaw9uwXNtwZPVkKNDx9G/OgAKClo+starYcWnf1TbJmDoyFqrHA0qqjVJ3g3rZNBo4c3IgP66wPwRcZHEtAQ6uE1dqsC8PXi+zd/b93fZbmzTtNbYykf8HmfyF48HYQM+B8fAMqh4P0/TdTSvajeKQkAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1816",
    "data-name": "Group 1816",
    transform: "translate(8.123 45.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1815",
    "data-name": "Group 1815",
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1814",
    "data-name": "Group 1814",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1813",
    "data-name": "Group 1813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1812",
    "data-name": "Group 1812",
    className: "cls-174"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2241",
    "data-name": "Rectangle 2241",
    width: 14.25,
    height: 10.478,
    transform: "translate(-0.16 -0.052)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAZCAIAAADbmGv7AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGnSURBVEhLtVUxTsNAELxzh3gLkA8kDYgPIKBBgjdQJnQkNU+AgOj4ACXhASR/ofax5/Gt17tnC5MwGtl7492Zsy0nvjzbd95thfNpXeTgL+LVKuY/4d++6Vi4EDIsjQJanRSwS69AMU6zNAqRRKtLBQ1M1jtjFNUYMyuCGAE7Ywgo0Me6FK0uaVC4y6luIhJwtFDvoIv63RBURw9pjLfCVDfHSxQVqhgCN2WJAQxb3S6FHl4XZJ/eDYD6b5R5AD+D9NB6KecVAbaTxOPFbHM3LFkylFHDdj8RVjhuVjRauINxfY2hXZhVmyQZsaMt0LP5JMvCH060XUwaQnbkIlJsK/9uWt2JSqQlK4D0jaLnOqxXJuY3GcTMVOOruUHM1UxfUIymvNlURDER4KWh+TwZ6iE0m+3edZwSPBq765l7ePc3dz4QnufuZVH3xVP1b1ovDZQul1SPxm40IXo6CsQYOoWTPazz7j3WBNp1zloixRynGMCGDbeWSDG3p24dv6MGNmmgtUSKWc7dMv6UbrnrLqSYpxRD2JF1CxQDlI/35ddHvdgtQvgBWQ3mYlkZwvUAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1821",
    "data-name": "Group 1821",
    transform: "translate(8.417 31.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1820",
    "data-name": "Group 1820",
    className: "cls-175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1819",
    "data-name": "Group 1819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1818",
    "data-name": "Group 1818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1817",
    "data-name": "Group 1817",
    className: "cls-176"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2243",
    "data-name": "Rectangle 2243",
    width: 15.088,
    height: 12.155,
    transform: "translate(-0.035 -0.343)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAdCAIAAABNF1mqAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJOSURBVEhLrVVBTlsxEB1nD9yBCMghwjIbglROQaVKrJAqwgESllUlBJvegQWqBF0mhygCeoh2H/PssefP9+AfoHl6mYxnJn4e+/uHvMHyfpq8dcPhQwr+eU7Xh+SIRme0PXT9/ZRYB4zY1Zj+LNIAkttD6g/daJIi/wcjdroVNBjssF1Hoy0xfzeju4uWBqAdNDo6+7BkW+xyTM9qD8UytCok37+3jZh/mtPlIfuteQXs61RodOL6wxRZhV76Bh4XtPS4CpEQr3AZLQCLbbge+69b/tcshlZAdfb9gJ4WZU9OxhKJFigrVz9ESuxkM3xV58rjakG29duSxPzPGYHye8D6yapEK64sAMc0ms8Mipo2IpRz5RpbyYcKe3+Bl5HHoeKtFJE7+7LxypIFer1igTSMXxIEdJnYz7eqs+ZRBPMya5TlBxt/EqwqsORt9LfTMiGqDA6KwxqWHTcnHl7srEho4vcdU4C6RXYCYz33yik8othLnJk/3giSdtMFNtVxE4BU01j37S+s6kxW9xZKx7z8EDEz8BA2v896/mEeQgyp46Kar4chYra6KMhXrUe/o1iRBoEiwtRxu4hGWBXs5M6CwZitpp5IZzkuWV2mKapL73Z0Z0BRCupgMSNDRwqiXtZ00LwkIbZo1TF0xJLn4ul4qFPiCzN6ZVQPu6mLX9Xm4K5+EQ/U/ywXWdqUjYCFTPTdXiPW/J8x/M00ecBN5/+vvsUCc7Xdj39xEFCK1fDBRRxN3Kfz5L9drIYVi4DY0frEakiLGOy7QT4zohcneo51u2PmqwAAAABJRU5ErkJggg=="
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1826",
    "data-name": "Group 1826",
    transform: "translate(12.763 19.732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1825",
    "data-name": "Group 1825",
    className: "cls-177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1824",
    "data-name": "Group 1824",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1823",
    "data-name": "Group 1823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1822",
    "data-name": "Group 1822",
    className: "cls-178"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2245",
    "data-name": "Rectangle 2245",
    width: 15.927,
    height: 14.669,
    transform: "translate(-0.189 -0.135)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAjCAIAAAB3ku9KAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAL3SURBVFhHrVZLbhQxELX7BoRdIAyHYIHUSJwgPUgICYT4nCKwAyEkiNhwBFigSCABMzkAIM3cg5BMlrlBbMr1bHfZ7enJdObppfKqPMlzld2dKHthnE8as5j55BLQ9KUuADMZq9O50kpt11Uz8dVBqPz3XpifY7WYK9ob8XRupmO/MAirLc2PsTphP8ImXFdYWjKDX8bFcNc+S3sys98bnxDICYAY2mvf9TEfr7r7QqCotdBBEK6tfZuWdmm+NX6GBCes0IGE9Sdc7tJ8bdwRym7QHPWaV1iv02uhS3s8U8fhyrg8REdOkgrrdXotdGk+bJUbiiIuJcWLviXyLs3Bbtg+bwX7QQXCEOlc+Wgzcq+WXlK9SLq0/2b2gJ+KpANWbSqEvMaITN1M9HbNpQISS/MOI+Uk+S2cyEoUS4bc49oO1nzZ9ardQxxaZ5JyqdUt7fIJe0t7NFNHpRebW+PzcynydIlIRwsdwfVlrn6w5u0WZ4HQ3ejICTTg60Q+WjDUuxN2Xdo/+36PvLvQ0xJm1zX+lGM6fGa3V9eleRNalDFLEaXo3ilPcY0DZa+V+cQPIiGLkUgRpYgXB/BFrrfaU/Za6Zt33Hda6MaMsQjR806IF0owuvrrY3/vuxN1BRd8JMQUhJbRk3PorN5qRzfh5O0TjQn0CRm7AlEKadwycdXj1BJwp0vPKIE+hBgFYp9ghUpL76rvTTT9mePPJqieH+pnUzWqs8PwdEcotBQ4XQKKoFty561v7ZEfLRa6jLB/ZzTqtmMifRYiVmSK6CnmSdipq/tTVr2WgDP+HP7pws/HXwQBTZApjS+6Xq+rB96PUBhsBnqKqldn+u4Ll2B7FKXAVIFkiZ8fo/TtPS55rO5SovAsQRBIYP8ohiX9cKp3+NEPWM8SKD/E0QZE5UZdPTrkpMUQS0J+sxClYFYvz7iUYKAl0BpnZqz146keJSMFLmUJlI1HdfUkHymwAUsgOWBq8Wm5RQey3CDMr/fnr69Q9HkX1v4HCse680jXnfkAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1831",
    "data-name": "Group 1831",
    transform: "translate(21.732 11.408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1830",
    "data-name": "Group 1830",
    className: "cls-179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1829",
    "data-name": "Group 1829",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1828",
    "data-name": "Group 1828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1827",
    "data-name": "Group 1827",
    className: "cls-180"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2247",
    "data-name": "Rectangle 2247",
    width: 14.669,
    height: 15.927,
    transform: "translate(-0.357 -0.194)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAmCAIAAADBdrW9AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALySURBVFhHnZa9jtNAEMe9foMQXVJTAAIhCqhwOtD1yVU8SPIUyWNQX64/hESRnOj5RkDLBdC9gZeZnd3Z2Q9vzv5pksyOvZ75747tKK11NRT9c6Nv9vWzczsuMjCT/rGBNJWCC1Tq6bkaNfZAN70z6e8bSEM5rI2a28jqkUn/2+n3Z5UCFSKNsfrlb3tSN7X9LaL/7tqrhb46q6AqqAy/jTlwJY9xXJP+stbfwuUaJKukSf/ZtRcT/dXVy1KkLGdHZXVq0p/WoAbrreETlG+st6yMJn3Yte/m+vPajU0ponxjvWXFmvSHNaiJijUWigBYK1Tr4gVZgab27Vx/NFLCYi1RhEsU8YIsq0lf70BNddhzdTkzsnCSM7mFTlmXLNSEad4squs9BkSBiZm9kciVd6fBk9BGQmpMc7ng8wI4yJYJutZw6F/5BazVdFZN3fPRzzfG+KCMhtAJwM0+KwtXrz69QFdehKaxMTh0IrwJWS062b6wvadOt/jDkwkeRpYeIsiB75wsl2k6i5OREVEkXcN0txJZNhOAyZ6s7MBfNJiPRIfYCB4msnwmADNBd/DZBWvhEwXF/hFhpswTtr2c471F9yMYwD4Y1UZO9IiCGzkYBndxoInAVpTKAFkM+zJIRLsVNmEmE2A3jKbRTPalwRpGEbmG4Iq7uCNTVytKI8JLW9gXskpvd/ugAuTqs+E+kZO+FeFBaxzzTbuV10T4vncFWoegIVqyhsFRK6ukiYhbMTJWJvsQg06WGYKskiYibsXIzIMOTUJDjhtZxzUR7esJ/nDVplJEFF6SNW7o9ONkWhHURJG0D8kZNeru8raaANuKUCDgC4+cUNZ4pu4t1R18//XIBPi+50vzRb1jkp006v5SjWdmHgJHeuBf0LQsZMlQPVjWz7cyDdBPExH3vdQ3adTDlToJchBDMgHZZOrxSj1yb7iEgZkA7HvOBGlebNUkI4Xpt08S7HvamJOmfnUopwGGawKgFWEN/X+CAlX1H0oMI2UhJ/aHAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1836",
    "data-name": "Group 1836",
    transform: "translate(34.106 7.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1835",
    "data-name": "Group 1835",
    className: "cls-181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1834",
    "data-name": "Group 1834",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1833",
    "data-name": "Group 1833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1832",
    "data-name": "Group 1832",
    className: "cls-182"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2249",
    "data-name": "Rectangle 2249",
    width: 11.316,
    height: 15.088,
    transform: "translate(-0.157 -0.41)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAkCAIAAAD3mtZ6AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAILSURBVEhLrZZLUsMwDIbtbOiitGwYFgXOQbhVyzVoOQj3IL0HZdjyKAU2FbIUO5IfSTvDN677R7H+SE3HiQUA8x/AT2NHNYqjHWHXmO/GWNJvD07QsGdzO11gcMARto3ZNc4Fh082FRp47UefI3w+ma8GtmvlooY1VRTJOcLLEk/A60qsE7UoCx+XwdFNdfHoHPfP97BZpdekcYwj1n39jI4VfDRUoR4pBwcrO3G3vAOvhpTy03gSqezlXSuZrNcgIgt/CWOwTL6+tHOHoCJMGkfNnRHOUTWet8jFC5Bj2ng3hJOQjujQQ10704Vw4ZhHHkotOuUseF+hbB3Nqb7jPQRTcknxNU5vWbREq/kwl5/ia5SNB0oWvWs6R/cfYqSv0yKpi+eChKhxkjQeyGptFBA1po2XdC/Kcbhx/panGBL4YMBZ14iN47k04UB+1zjpGtH0yu3DGa/oMuWLxY6q8TAzsSl9yQVEUqO8421mJk0RlhFJjdEdD16hohBBpPZkHf1WxAkhbciLyTg6Sr9mdJgj7+j2YEyLB35IMCz0jBtawTHag4+h0DXCZSLZmQV/tbql6Bg/dVM6X8LrsiM3zut0FYrkVLlrhMsMpk7456qcEeA3qbk5qfve9mCz7F6JcG6FNePajmvU9pw2Ac3A++N+PWvtMH+2wAecHeuNOWHojXSzxPmIP5MxfzkuAinV0AE/AAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1841",
    "data-name": "Group 1841",
    transform: "translate(47.688 7.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1840",
    "data-name": "Group 1840",
    className: "cls-183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1839",
    "data-name": "Group 1839",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1838",
    "data-name": "Group 1838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1837",
    "data-name": "Group 1837",
    className: "cls-184"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2251",
    "data-name": "Rectangle 2251",
    width: 10.897,
    height: 14.669,
    transform: "translate(-0.327 -0.355)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAjCAIAAAAFXY38AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHwSURBVEhLrZYLTsMwEETXoXyExHnordqjtLfgJqS34BaVCo2Z9TjO+tMkFTyt3F0XT2ZtA3EefPf+pxcn3cte/obKDeeDPx+kQyXTqIlzm52Wmm4RYckcC3Kap0mUyruTLcpOdqHMyOWSVhyDXCyppfiQevFev9x1skWEbxblmGsZNAJWDjGEsQuu8eM5XKUSwdoslCNXOV3kUMk1aekmIcsKuVmPNMh4kv06d4a0cWG0+Idp76wF5IWjeEUyci0tN9lRNJaUk4UEwSQCnSKfbbb5AF2sV4SkBJ1izOVWGLQYUY9Okaic3uEEFmvcuHTjJBtMyXPoFMw2u4RxF1mSo9McOjJafp27Vr+8cQkUPAQyyjV3KocXWJNxZNKSA9rXGAmbVwTFqVNwu9mWULpxHIG1BpaOYiStD44m7pHTxjOThWjRKWjJ8Q4XzTpdjE8KkcIaWNssSUIA+Z1yxqA9BAb4X3fx197S4d9Y3KkUFdy1BN0Vh0Aqd5SL0qO2nsMUAA+oOwXNk42f86yWowHD6CiOCP4przFybDAlucf8EY1DIPXe5TIqFKXoi0mzU+CGyydf7lRZt7wXf9JcS5X2zvMtJI14HXmVD64v0FeemFYM/ojRu/4qvVV8lF3zloA5OcsgKnqR4yD+Tb7ibIHIL9ZTz1YTmNBzAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1846",
    "data-name": "Group 1846",
    transform: "translate(56.853 10.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1845",
    "data-name": "Group 1845",
    className: "cls-185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1844",
    "data-name": "Group 1844",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1843",
    "data-name": "Group 1843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1842",
    "data-name": "Group 1842",
    className: "cls-186"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2253",
    "data-name": "Rectangle 2253",
    width: 14.25,
    height: 15.927,
    transform: "translate(-0.272 -0.178)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAmCAIAAAAutN6DAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALjSURBVFhHlZZRbhMxEIZ/+kARbeEJEBUpQlAOwFPCPdKeozlIyzm6nKPJJUAiFVJVibw0FWkfWH57bO/Ya+9uPk1Te9brf8cz3jXqATzUV3/q6aa+cv3tecI/9LHC6QPmHPcU4wOc7WLiLgxmkMwNjjgoGMVe4OzZNmI77n+ZNS60Bm2DxS1Ob3CywdwN6qM/miSU2OpdjA9RuaFleqIJoRA1u5h5wL9Y/MBohXM7pEhPNN2hJJ53uHxeSFhXNI9q6ZMZqeEuKK5xssTUdWK6ZNb4FuaNMY5wSds9Fr8wvW+VRnHRGAq3y7/WRNaa5SLxGOPj3yvMXmNmrxuK0TxiYe7oIx7jNGi3OP+J6dqHVYxGkp+LJs28MneJBOdHVPuY5GVYx3etXWkt1ZDnIB3yRZlQx61oSnNl/MS360xupI7DUEFG+9uCJ7IE76+PUWVkpI4FP1SaDVHH92SkNnKM7wf4msowFJoeJwRPy/LLJeybD4d5L6QyOhTSvlPw/lKqjO1hzFBkfFoCTH62iHNOmvGTlp9Wf8Fve9EQRSPvY5LcIE6S9cdOMabdxSFE0SRb0jcyK2MvZfzWTGkx7W5SSxNN+9Pimw5x+kvO77sN3IyJBmlkku1iG9Hzeiet8Quhy9L6HC+X4GRsHbt3pdwQGi0rrRUtTUnAyehPS7BA4i9YUYMYmbAlY6KV8Q3zIx4NPXa3F49UIlNcrtAOjaQtFnZ7CVPQekuGIpZG8Iuz5THG3Z5Nu2YnOe0R3RCsx62h7warezXIDk+qcjNhwz5sNKP2aL/QkXYNZSaHWPIA7qdwM0jXdVRX2yez2wedpF1B8+g9wvKlF4vNhEK0k/SmXZP5SPOkusKFKgG3Yjr51Bi4XEL+LECuzamOhR59Anw7eskPwS1amxGqI1zKIwQZ2+7a7SWKMoTn7veo+BtkrMbQtGu6ZMgeJh9QvcFMZNhtv+SHUMxNAo+pd5i/VcfiLQD+A7r5Co1X8UUNAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1851",
    "data-name": "Group 1851",
    transform: "translate(64.63 18.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1850",
    "data-name": "Group 1850",
    className: "cls-187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1849",
    "data-name": "Group 1849",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1848",
    "data-name": "Group 1848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1847",
    "data-name": "Group 1847",
    className: "cls-188"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2255",
    "data-name": "Rectangle 2255",
    width: 15.927,
    height: 15.088,
    transform: "translate(-0.086 -0.222)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAkCAIAAABql9/yAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKtSURBVFhHrZZNbtRAEIXfcABAIkGw4QAZiV0WHhaENQukmbnJhGNwE5JIWbJDAVuJBAGxZg0CQpILxDx3Vbfb3e2/mKeXnqp2u79UueWZWVmWmKBr5NconmCj+QBNQpL3DWvefw/ZUxzobJ/u6Od4OR59ieIKuV7o0y2RPo+mvmA9kHobZMBzPsf6cgB1NDKuj5KA4+cB1HFInyeS2Pd3vNFrLRpxYuP6XOylVXgf2S4OzVxCQ6tse360iDDh8e8vijMsZT7WIGTb8/OsvZKUIvW0hdqP7KiPpoQX+wLFReoo9TzLJI/yYuX5ky6lXuKH+azVVWV3fcbp+igX51F7W5HTeSYo/yCnTaZKN1Z4N4ktxIlmutgL6mWv8NN8VkpU6fN825kunjfTWHbitTdEtvGsdaPY3i1cEy77jZwWRKOx8fPjRpRNdakbA8tg40SwMu2tq0yeF8rGkmnKf6XZCa0sbo/MyI3vTXu1yiTPui7OOUjjBsgYTz7HYVVlLy+2Vw0XpNdELneweYjF7Kr86M4L1VxE19tRXEa5NICZmfS4jcUO9sljPDspH3PWR8q+N2bCZ4htWsFsrJZURgmobWQG9kxzHp+7yNw6B27jWWtxsl4crBSxk3s48nlUdXy+YsXvGu+GRjNdbK1X5ZKMcTrHZo7XZiKUnthzpdYwMeVKD66amTpwY9zJQPWr4FNFzWWX2ByimUZA9cJEjbfPO1RHKbLCKG9SUzcSNse+CXvUQLLKM6xkR7GcI5fGMbWF7AWOTDhIDSTFnw6nNbUMDm0QD+xkoBBJFVjyS9VtLZfjdA8HY2GiBJI6xiPZ3VUpowTDH1tSaSSr/IClIB2PGvvYkkr/9tnC4gEW/suFj41fAtN5VLpK0Vttb8n3yJROBupC/jK/Hv4jrBLwD8Qx2h84jX53AAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1856",
    "data-name": "Group 1856",
    transform: "translate(69.969 30.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1855",
    "data-name": "Group 1855",
    className: "cls-189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1854",
    "data-name": "Group 1854"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1853",
    "data-name": "Group 1853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1852",
    "data-name": "Group 1852",
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2257",
    "data-name": "Rectangle 2257",
    width: 15.508,
    height: 12.155,
    transform: "translate(-0.395 -0.211)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAdCAIAAACi1TKUAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJySURBVEhLrVZBbhQxEOzsFyIkghB8gQscWJI7QqB9BAckJDgRfgBK9hGcuYULPIBdCYlDeAM5gARvyFLjarfL9oxINimVnHK73TXtmdnJzmazsevGD1tivGdvOFVcs9+pHdMMRR/byZ7NGQ/M/O/V8NvWcPpgN05tCSfyl619WXDV/uCEhlA6qtCMeG5/XGVs76dHR1Do+MRObtVHuo0fnbQuoNMI7tnDp/bJJwmX8Es3aYmxKarTfnxRH+mFnhd4fLHFZ1vwPinPZRzldzv2Kgn/6U+PDqBoxlgFZMnr4v4t5Egn/fqbhBHcqacUgRT0QMRf2l9XvV/cJOi0eUCMkdrE+beeFvHADkHq4kcnvqS6hzoEkYPlYiHYukYIiFe5xcGvPzrc/wAiJCFikGNxh4rX2W+GtmgW1IetfvA250NDwbI6+nwCob/lp3R20+bI5gYK1bGBBg2BEEATbEgM7x8+HJhr9ayHPtBTaqskdJfiQY6aRgGe2ar44ash2eXQdLMSaCLkWLJXO8vfisEPryR+6FL24MHUZrNOqTGOJfu1ZkbcW/TfM7SIZS0aZBDQqWYmHadS4nnJ+TO16H737RBrUSvyGpHHuPxxGzA2Bgn3A3CqTQb2BDnNNiWHZEKvlav0SrR+kZ0FDUofiCt1S+g+TgLF73b3lCZy6htUBwGKfqnhVzuq/KIP7mz2j5qBU8k6JYHq+/DRnuFF4VzHgE6ndIM7Nr+b/oVBzoG9rfzWdrROdxWhvkRE+iUCB4OK1MnmEbWi8lslv8Zsqnpc+FTpUVR+wHvb7Q0QOcgfzP3cwXZo/d7Z7n4ufakLvxDM/gHXyY127OILZwAAAABJRU5ErkJggg=="
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1861",
    "data-name": "Group 1861",
    transform: "translate(71.533 44.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1860",
    "data-name": "Group 1860",
    className: "cls-191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1859",
    "data-name": "Group 1859",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1858",
    "data-name": "Group 1858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1857",
    "data-name": "Group 1857",
    className: "cls-192"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2259",
    "data-name": "Rectangle 2259",
    width: 14.25,
    height: 10.478,
    transform: "translate(-0.282 -0.256)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAZCAIAAADbmGv7AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGoSURBVEhLvVZBTsMwENzyAMQbAJVPpCeOIHgIN05EPKCceAC8AiSuXNpHgATiDXBvzdjrTDeb1Ipaymjkzo7XnliJko5CCPIX+JI5mAsD7H4oVY55lTt1LWx+b4MD+kdZrgDzVG5yzK0cqAvY3YfA9tsY+ojZU7U0xDSFklPWd6Wl84EcY6fZ4Uqy11Sum2rF7A45Ztf4x5hPmS0lKMMw6uLhiDEfMuetU+FKvXOW5cvSrQ1CjEnL8kiydAKjJadYpjFfhBIRqxhLOlxJob5SfWuyzZExYdGE49RpXDXZXTbz48vmSvYRxvcEBIg5hfVbv1Y1Ou6YBIHyXr7jaRhOLpqroEOtZ+WhVSTt2jKhgRiDTXWuSy6z5HrVjXCp1CnmWaba2g2j093UlSowWtFo/MqeFhvQLWw2bfnQR1LFmBOpLqQeS8W+3rFgKteZxzJBTOsj/Saz9/ShfZKpOoA+OXYkCiag4kzqc6lL/wU0jNnl7XpnMV7Ly1gmpRiL7kFdjAUzgAf5iXpgjIM7qKIbDPG4TYxF4Y7i4bqUOpbbxzjYgyIjxoj8Ai6t+qMoikCQAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1866",
    "data-name": "Group 1866",
    transform: "translate(67.821 54.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1865",
    "data-name": "Group 1865",
    className: "cls-193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1864",
    "data-name": "Group 1864",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1863",
    "data-name": "Group 1863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1862",
    "data-name": "Group 1862",
    className: "cls-194"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2261",
    "data-name": "Rectangle 2261",
    width: 15.927,
    height: 13.831,
    transform: "translate(-0.342 -0.105)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAhCAIAAAA6Wk5BAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALdSURBVEhLrVdNT1NBFD1FV/Af/AFiAH9Au7QQt9YYY+LHXuPClTSGxJaFiRvZazTERHRlXAhxY7sXEvCnIDueZ+bOu70zb14fFE4ut2fuzHtnzrzp9IEihy/FoFfM7xSDo+J3KF0eWvxDBXewwNzyQfTw8jrai+j41kWRkTzC6BXWRExVCRKv3VlEO5RmQkayj9W/GKukIKc9o+9U8hCjPtZIrGSiZzO1e1j3rbNiLnyWOMT4lFsKOAWYG2MHm3exsIHVrxiGWzQhdXkb8+qg5c14EmC6ArQi4GNmTPcdSW5j+BnD5L4+twzPZCIp+ied144ku96iBqGE8GSirURgm7ZY1Z5IfsJgG5uuFIdU4uyEpUlUetMugkS1g+QBRi9o0vWF28loS2z2JLPaxPQihcOO/YhBuUU5BTcL3bHJ1iVKHkZKnHGHU9K5pMXn6HIKEkTJgw+irEy4wJCM6WQY8zccO5fP0JUpcKbxZAv5jkrY3sQTkZjOBs8NjrxybePqPsb+qggcISiJzjhUdEAOYXAy5jV+Ms89Qf8x1tlno+rG220wIeEvyQzmdhVht7BUfYfdZbSlL1m0OLjUjlTnpEGUPBK+51eViI6C9xh8MKePZEu0yU9bt4TQismt7zj2ND7Wrd06r2XdOeAlWmfUXcJQi0TkUiF2SXTuQoQTcd1RW6nmH/jnqUP64yUQuyvl09Wo8REemO21/Eb8FpGXJG6is4W96mauCbfOoi1ihPbej39P8gtrsY8RzwqSZK2qpMzhlJbmEtpvsOtbAbUuFbQ7xoldZCIhcTPYlXhQ+clslhRwkfl0SfReTeGEqbdUeSVrXtgET3HrwB+QdvUkJ03iF078Z4SzulRMsZvs57fxI1ScW5LQp6sahGYJ7prlmrfcWSQFtLtVY5d4yDfwGswuSVQ3swSPzJX6F/lzb58sku/uKLdrFBdyqbB2H019b3agy0vEn8b/R4viPzrTpIWHlh+YAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1871",
    "data-name": "Group 1871",
    transform: "translate(61.214 62.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1870",
    "data-name": "Group 1870",
    className: "cls-195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1869",
    "data-name": "Group 1869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1868",
    "data-name": "Group 1868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1867",
    "data-name": "Group 1867",
    className: "cls-196"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2263",
    "data-name": "Rectangle 2263",
    width: 15.088,
    height: 15.927,
    transform: "translate(-0.023 -0.334)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAmCAIAAAAjqq7EAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAM1SURBVFhHpVfLThRBFD09Q8ZfAJ9f4COKICwGM+OwF9GFMcaYwMKtbEWFpSbEne8YowsX+gECZoZEUOSbKE/Xraqprq7u6YaTk0rdS3Wde2/dqgmJUgqlOMAASCbRNvZxQLES/FP9i6p1SbU4Ma5joExsX/XPq9YF1RK912rN/OGoKCzjPgYP0UuQJCwi0NBOFvMdNvX0KJBNQlDpAXqMwvFQjwfYWULPLKqPiNhfDO4PlXSlrSRJvcs4wdGsroNQjEr3cMPfPcpl9HSX1kNG7A8Gd41SJpt8fuQS5t9g3XxZDcMG2cDaK6xT3HWE6w6PqYdwnlotY8TuoMu0GtndA9OSg2/W0GvsYrCILkdqHkaq55vC0Fm9ZZJx1fAvk57ETZ8cAg/5Fj8nMae3jaMxg+sSIOGCFcrdiuZnBgtxLmO+vEWT36p/C90gRv+0iIJmIVMnIaZMSo6wMYu579jOhT80icDjUdnsU8rKkleGQYN6fjEJPc/vHtfzTflW9PItM7xnExiTamSZr17oIQqcYcukmQl0MdO4WBmvOGE2HHIejtGkw5bJ/MQsoLOHHT9AzcTeAUMilnHq9uZD/xXbMsPMiB/4NYM5PzTNTNQj74OdmwnpWib88eRTkr8JLg/Cc5Ijzk+bZnIV7UxmBDvzMVZdUJaMKBtUDrJST0zS+VsRZiZYQHcPAxegx/xRpR7Cd2ozUwym9R6bYWaCFayamRedpok68ATLtGlWEnxTqMRJXEw/K1tc6peimGV6VPpgX6+4GDGL6+xMY2QgWxnY3Y0eYT0pWL2P3jsZPzMHPiscpfoeo01IZs5pGu1P2NKWQWFmAj4rHF2wlgwwjVGYf27kk0d4oqdDjBDTb3SkmHZ3szVhTaP3GZtTuQ9HlFFQUMzUF3hI4gu2pmMhjshMEPvBS2kGzzOFdpESUUmMxVzBU2NouN0lCPGwI75iu0gpBctYETdVZ1w1J1TzpGqeUs3TmmdU86waO6fGNtRzs64Ylc5MIG80J8Ehkd+wfa0kIQfRrIgX6pmfHHlbdXYr/59YT4zwi7moOsZbDbXFCIqRLyscUoAaZ+awiz5Pii1q7IoA/gMnIxsbj7ELbwAAAABJRU5ErkJggg=="
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1876",
    "data-name": "Group 1876",
    transform: "translate(55.755 68.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1875",
    "data-name": "Group 1875",
    className: "cls-197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1874",
    "data-name": "Group 1874",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1873",
    "data-name": "Group 1873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1872",
    "data-name": "Group 1872",
    className: "cls-198"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_2265",
    "data-name": "Rectangle 2265",
    width: 9.64,
    height: 13.831,
    transform: "translate(-0.012 -0.034)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAhCAIAAAC9a6dHAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGsSURBVEhLnZZ9TsMwDMWdjW+4UwsIwbhUOyS4Vhk3QRyB/zEvtZe6SZoGnqIt6dJfnh2nK/FcBx4eub1m98GDXqrQRHnh7pzdBbsrdqA8cas/VMhTeu62TKdMZ0wAXR5B9XaImBzThulkBIkdgP5kZ6LADkD/s0MddwISirUD0A07nVjUpqWWRsGWyOdKu/7iG+11UBBIDTeYHgUVslNjZwOQ2LHrB6FfY8ev47/IOf/pG8BjR6/I8Jt+5IasvBeooUaWNU02UNuObmVmXhLYwAPmplseNqu860qBIspYys7WTqEIJ0ooHAGFA2FrZ8nORIFSO1FQuwU7M4oUjq1jCWo1O7pHIlvHx4aFfCfome60Z6W0o+TWuZ04rlc8S+aKKVGOs9lJz8QsIigEZRXiCi0+E0ozwqzISxpUtOsZSjaodLNsEWYo0F/t5CmhcMqgYCdPSQ9n2U6eAoFSn51t3/e6W4kOdJAH1bxNzzO0L/r0U2XlVBJUjR3EtUiBVnOMf/SVvEALheMpD9zivUDnlSlQGtQ9N+/mftEKxdrZY7SgFYrkGC8VOs6K+RemiBvuROXk/wAAAABJRU5ErkJggg=="
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1878",
    "data-name": "Group 1878",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1877",
    "data-name": "Group 1877",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    className: "cls-6",
    d: "M48.592,57.755a10.179,10.179,0,0,1-1.718-2.461l-.021-.005a3.273,3.273,0,0,1-.783,1.228,5.969,5.969,0,0,1-1.271,1,6.666,6.666,0,0,1-1.6.685,6.41,6.41,0,0,1-1.777.256,6.06,6.06,0,0,1-2.641-.587,6.639,6.639,0,0,1-2.151-1.625A7.963,7.963,0,0,1,35.159,53.8a8.136,8.136,0,0,1-.549-3.01,8.279,8.279,0,0,1,.527-3.016,7.74,7.74,0,0,1,1.429-2.385A6.3,6.3,0,0,1,38.718,43.8a6.415,6.415,0,0,1,2.657-.565,6.159,6.159,0,0,1,3.13.8,5.491,5.491,0,0,1,2.038,1.984A10.17,10.17,0,0,1,48.472,43a9.068,9.068,0,0,0-1.755-1.391,9.926,9.926,0,0,0-5.26-1.347,10.2,10.2,0,0,0-7.515,3.108,10.025,10.025,0,0,0-2.109,3.347,11.421,11.421,0,0,0,.017,8.157,10.493,10.493,0,0,0,2.135,3.385,10.157,10.157,0,0,0,7.51,3.168,10.671,10.671,0,0,0,2.913-.391,10.8,10.8,0,0,0,2.527-1.054,8.158,8.158,0,0,0,1.972-1.609c.049-.054.1-.108.147-.168-.157-.141-.315-.293-.462-.451",
    transform: "translate(-3.943 -5.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    className: "cls-6",
    d: "M72.111,46.737a10.13,10.13,0,0,0-2.054-3.326,10.017,10.017,0,0,0-7.434-3.15A10.4,10.4,0,0,0,58.4,41.1a10.181,10.181,0,0,0-5.458,5.654,10.9,10.9,0,0,0-.763,4.069,11.045,11.045,0,0,0,.763,4.089A10.415,10.415,0,0,0,55.072,58.3a9.972,9.972,0,0,0,3.287,2.289,10.4,10.4,0,0,0,4.225.842,10.944,10.944,0,0,0,2.935-.391,10.528,10.528,0,0,0,2.563-1.077,9.19,9.19,0,0,0,2.034-1.623,7.521,7.521,0,0,0,1.389-2.075l-2.974-.821a4.3,4.3,0,0,1-.919,1.408,5.832,5.832,0,0,1-1.389,1.057,7.988,7.988,0,0,1-1.682.685,6.71,6.71,0,0,1-1.839.254,6.361,6.361,0,0,1-2.524-.508A8.051,8.051,0,0,1,55.664,51.8a8.567,8.567,0,0,1,2.246-7.1,6.62,6.62,0,0,1,2.132-1.369,6.942,6.942,0,0,1,7.3,1.349,7.208,7.208,0,0,1,1.525,2.094,7.366,7.366,0,0,1,.724,2.68H59.162V52H72.757a4.249,4.249,0,0,0,.059-.548c.012-.234.019-.5.019-.782a10.955,10.955,0,0,0-.724-3.932",
    transform: "translate(-6.618 -5.106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    className: "cls-4",
    d: "M631.076,33.976a8.414,8.414,0,0,1-3.143-.576,7.644,7.644,0,0,1-2.5-1.593,7.172,7.172,0,0,1-1.645-2.4,8,8,0,0,1,0-6.014A7.06,7.06,0,0,1,625.429,21a7.778,7.778,0,0,1,2.5-1.582,8.89,8.89,0,0,1,6.3,0A7.875,7.875,0,0,1,636.756,21a7.256,7.256,0,0,1,1.677,2.389,7.49,7.49,0,0,1-1.677,8.414A7.738,7.738,0,0,1,634.23,33.4a8.5,8.5,0,0,1-3.154.576m0-1.027a7.263,7.263,0,0,0,2.661-.482,6.576,6.576,0,0,0,2.148-1.341,6.183,6.183,0,0,0,1.435-2.064,6.524,6.524,0,0,0,.524-2.63,6.439,6.439,0,0,0-1.928-4.652A6.559,6.559,0,0,0,633.78,20.4a7.108,7.108,0,0,0-2.7-.5,7.029,7.029,0,0,0-2.693.5,6.464,6.464,0,0,0-2.117,1.383,6.373,6.373,0,0,0-1.394,2.064,6.444,6.444,0,0,0-.5,2.546,6.573,6.573,0,0,0,.5,2.578,6.463,6.463,0,0,0,1.394,2.085,6.367,6.367,0,0,0,2.117,1.394,7.029,7.029,0,0,0,2.693.5m-3.395-11.191h4.086a2.571,2.571,0,0,1,1.184.272,3.081,3.081,0,0,1,.922.713,3.411,3.411,0,0,1,.608.985,2.941,2.941,0,0,1,.22,1.111,3.039,3.039,0,0,1-.461,1.614,2.447,2.447,0,0,1-1.215,1.048l2.158,3.479h-2.242l-1.928-3.1h-1.341v3.1h-1.991Zm3.919,4.4a1.079,1.079,0,0,0,.838-.346,1.4,1.4,0,0,0,.314-.974,1.282,1.282,0,0,0-.356-1,1.2,1.2,0,0,0-.838-.325h-1.886v2.64Z",
    transform: "translate(-79.04 -2.39)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCeLogoFull);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ce-logo-full.773105cce7e447603ba942aab52ba740.svg";